import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import { myConfig } from "../config";
import { useHistory, useParams } from "react-router-dom";
import { Cancel, Flag, SettingsPhone } from "@material-ui/icons";
import codeJson from "../CountryCodes.json";
import lang from "./lang.json";
import ScriptInjector from "./scriptInjector";
function LandingPage(props) {
  const [faqs, setFaqs] = useState([]);
  const [productdetails, setproductdetails] = useState({});
  const [lan, setlan] = useState({});
  const [trakinid, settrakingid] = useState("");
  const [countycoded, setcountrycode] = useState("");
  const [dubai, setdubai] = useState(/dubai/);
  const [uae, setuae] = useState(/uae/);
  const [zong, setzong] = useState(/zong/);
  // const [virgin, setvirgin] = useState(/virgin/);
  const [virgin, setvirgin] = useState(/kwzain/)
  const [voda, setvoda] = useState(/voda/);
  const [beeline, setbeeline] = useState(/beeline/);
  const [tmobile, settmobile] = useState(/tmobile/);
  const [orange, setorange] = useState(/orange/);
  const [sierra, setsierra] = useState(/sierra/);
  const [play, setplay] = useState(/play/);
  const [plus, setplus] = useState(/plus/);
  const [grameen, setgrameen] = useState(/grameen/);
  const [phone, getphone] = useState("");
  const [phones, getphones] = useState("");
  const [sCountryCode, setsCountrycode] = useState();
  const [userip, setuserip] = useState("");
  const [browser, setbrowser] = useState("");
  const [operator_id, setoperator_id] = useState(0);
  const [otp, getotp] = useState("");
  const [conuty, getcountry] = useState("");
  const [conutys, getcountrys] = useState("");
  const [cgflow, setcgflow] = useState(false);
  const [checkflow, setcheckflow] = useState(false);
  const [show1, setshow1] = useState(false);
  const [show2, setshow2] = useState(false);
  const [apiError, setapiError] = useState("");

  const [IsUpdate, setIsUpdate] = useState(false);
  const [playtype, setplantype] = useState("daily");
  const [service_no, setserviceno] = useState("skysport_daily");
  const [plan, setplan] = useState("daily");
  const [bulletImage, setbulletImage] = useState(
    "data:image/png;base64,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"
  );
  const [aff_id, setaff_id] = useState(0);
  const [acrValue, setAcrValue] = useState(null);
  const [scriptCode, setScript] = useState('');
  const [click_id, setclick_id] = useState("");
  const [camp_id, setcamp_id] = useState(0);
  const [TransID,setTransID] = useState([])
  const [otpAcrValue,setotpAcrValues] = useState([])
  let history = useHistory();
  let { id } = useParams();

  const [hasMsisdn, setHasMsisdn] = useState(false);
  const [isZainPromo, setIsZainPromo] = useState(false);

  const [isReadonly, setIsReadonly] = useState(false); 
  

  //  useEffect(() => {
  //       let queryString = window.location.search;

  //       // Handle HashRouter URLs like #/page?msisdn=...
  //       if (!queryString && window.location.hash.includes("?")) {
  //           queryString = "?" + window.location.hash.split("?")[1];
  //       }

  //       const queryParams = new URLSearchParams(queryString);
  //       const msisdn = queryParams.get("msisdn");
  //       const pathname = window.location.pathname;

  //       const isZain = pathname.includes("/kwzain/promo");

  //       // Define when OTP should be shown (only when msisdn is explicitly empty or null string)
  //       const showOtp = msisdn !== null && (msisdn.trim() === "" || msisdn.toLowerCase() === "nomsisdn");

  //       setIsZainPromo(isZain);
  //       setHasMsisdn(showOtp); // now hasMsisdn means showOtp

  //       console.log("msisdn param:", msisdn);
  //       console.log("showOtp (hasMsisdn state):", showOtp);
  //   }, []);

useEffect(() => {
  let queryString = window.location.search;

  // Handle HashRouter URLs like #/page?msisdn=...
  if (!queryString && window.location.hash.includes("?")) {
    queryString = "?" + window.location.hash.split("?")[1];
  }

  const queryParams = new URLSearchParams(queryString);
  const msisdn = queryParams.get("msisdn");
  const pathname = window.location.pathname;

  const isZain = pathname.includes("/kwzain/promo");

  let showOtp = false;
  let readonly = false;
  let prefilledNumber = "";

  if (msisdn !== null) {
    if (msisdn.trim() === "" || msisdn.toLowerCase() === "nomsisdn") {
      // Case 1: Empty or "nomsisdn" → input enabled
      showOtp = true;
      readonly = false;
    } else {
      // Case 2: msisdn has a real number → show in input, readonly
      showOtp = true;
      readonly = true;
      prefilledNumber = msisdn;
    }
  }

  setIsZainPromo(isZain);
  setHasMsisdn(showOtp);
  getphone(prefilledNumber);  // assuming phone state is used in input
  setIsReadonly(readonly);    // create new state for readonly handling

  console.log("msisdn param:", msisdn);
  console.log("showOtp (hasMsisdn state):", showOtp);
  console.log("readonly:", readonly);
}, []);





    

     const [rowMsidin, setRowmsdidn] = useState("");
    const [statusCode, setStatusCode] = useState(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);

        const aff_id = searchParams.get("aff_id");
        const click_id = searchParams.get("click_id");
        const camp_id = searchParams.get("camp_id");
        const plan = searchParams.get("plan");
        const msisdn = searchParams.get("msisdn");
        const status = searchParams.get("statusCode");

        setStatusCode(status); // store for later use

        if (msisdn && msisdn !== "nomsisdn" && msisdn !== "") {
            console.log("✅ Valid msisdn found:", msisdn);
            getphone(msisdn);
            setRowmsdidn(msisdn);
            getphones(msisdn);
        }

        if (aff_id) {
            localStorage.setItem("aff_id", aff_id);
            console.log("Saved aff_id to localStorage:", aff_id);
        }

        if (click_id) {
            localStorage.setItem("click_id", click_id);
            console.log("Saved click_id to localStorage:", click_id);
        }

        if (camp_id) {
            localStorage.setItem("camp_id", camp_id);
            console.log("Saved camp_id to localStorage:", camp_id);
        }

        if (plan) {
            localStorage.setItem("plan", plan);
            console.log("Saved plan to localStorage:", plan);
        }

    }, []);

    // useEffect(() => {
    //     console.log("Debug:", { rowMsidin, statusCode });

    //     if (
    //         rowMsidin &&
    //         rowMsidin !== "nomsisdn" &&
    //         rowMsidin !== "" &&
    //         (statusCode === "2" || statusCode === null)
    //     ) {
    //         console.log(" Calling sendotp()");
    //         sendotp();
    //     } else {
    //         console.log(" Not calling sendotp()");
    //     }
    // }, [rowMsidin, statusCode]);




  useEffect(() => {
    console.log("useEffect is running");
    var ev = new Event('DCBProtectRun');
    document.dispatchEvent(ev);
   
  }, [scriptCode]);

  async function checkActiveEffId(effId) {
    var otpurl = myConfig.billing_url + "check_affiliate.php?aff_id=" + effId;
    console.log(otpurl);
    axios.get(otpurl).then((Response) => {
      if (Response.data == "ACTIVE") {
      } else {
        window.location.href = "/fail?active=false";
      }
    });
  }
  async function subConfirm() {
  console.log("🚀 subConfirm() started");

  // Build request URL
  var otpurl =
    myConfig.billing_url +
    "subscription.php?affiliate=" +
    localStorage.getItem("aff_id") +
    "&cg_image_url=&mode=WAP&msisdn=" +
    localStorage.getItem("bmsisdn") +
    "&product_id=SEVdbkwzaindly" + 
    "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id=" +
    localStorage.getItem("aff_id") +
    "&camp_id=" +
    localStorage.getItem("camp_id") +
    "&other1=he_redirection" +
    "&other2=&aff_id=" +
    localStorage.getItem("aff_id") +
    "&aff_uniq_id=" +
    localStorage.getItem("click_id") +
    "&camp_id=" +
    localStorage.getItem("camp_id");

  console.log("🔗 Built OTP URL:", otpurl);

  var queryparams =
    "affiliate=" +
    localStorage.getItem("aff_id") +
    " | cg_image_url= | mode=WAP | msisdn=" +
    localStorage.getItem("bmsisdn") +
    " | product_id=SEVdbkwzaindly" + 
    " | result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | camp_id=" +
    localStorage.getItem("camp_id") +
    " | other1=he_redirection" +
    " | other2=&aff_id=" +
    localStorage.getItem("aff_id") +
    "&aff_uniq_id=" +
    localStorage.getItem("click_id") +
    "&camp_id=" +
    localStorage.getItem("camp_id");

  var gettime = new Date();
  var veriftotpurlreq =
    gettime +
    "| REQ |" +
    localStorage.getItem("bmsisdn") +
    "|" +
    myConfig.billing_url +
    "subscription.php" +
    "| POST Parameters =>" +
    queryparams;

  let finalobj9 = {
    security: "col#c4",
    logData: veriftotpurlreq,
  };

  axios.post(myConfig.billing_url + "appLog.php", finalobj9);

  try {
    console.log("📡 Sending GET request...");
    const response = await axios.get(otpurl);

    var veriftotpurlres =
      new Date() +
      "| RES |" +
      localStorage.getItem("bmsisdn") +
      "|" +
      myConfig.billing_url +
      "subscription.php" +
      "|" +
      JSON.stringify(response.data);

    var finalobj5 = {
      security: "col#c4",
      logData: veriftotpurlres,
    };

    axios.post(myConfig.billing_url + "appLog.php", finalobj5);

    // clear storage
    localStorage.removeItem("bmsisdn");
    localStorage.removeItem("aff_id");

    // ✅ handle success/fail
    if (response.data.status === "OK") {
      if (response.data?.url) {
        const redirUrl = new URL(response.data.url);
        const redirectedClickId = redirUrl.searchParams.get("clickid");

        if (redirectedClickId) {
          console.log("Stored redirected clickid:", redirectedClickId);
        }

        console.log("🔀 Redirecting to:", response.data.url);
        window.location.href = response.data.url; // ✅ redirect to success
      } else {
        console.warn("⚠️ No redirect URL provided, going to /fail");
        window.location.href = "/fail";
      }
    } else {
      console.error("❌ Subscription failed:", response.data);
      window.location.href = "/fail";
    }
  } catch (error) {
    console.error("🔥 Error in subscription API request:", error);
    window.location.href = "/fail";
  }
}

useEffect(() => {
  console.log("useEffect is running");

  if (window.location.pathname.includes("kwzain/promo")) {
    // check if already called
    if (!sessionStorage.getItem("subConfirmCalled")) {
      console.log("✅ First time on kwzain/promo — calling subConfirm()");
      subConfirm();
      sessionStorage.setItem("subConfirmCalled", "true"); // mark as called
    } else {
      console.log("⏭️ subConfirm already called — skipping");
    }
  } else {
    console.log("ℹ️ kwzain/promo not found in URL");
  }
}, []);


  async function callCancel() {
    localStorage.removeItem("bmsisdn");
    localStorage.removeItem("aff_id");
    window.location.href = "/fail";
  }
  useEffect(() => {
    var url = new URL(window.location.href);
    var aff_ids = url.searchParams.get("aff_id") ?? "1000";
    var camp_ids = url.searchParams.get("camp_id") ?? "0";
    axios.post(myConfig.billing_url + "stagingCount.php?aff_id=" + aff_ids + "&operator_id=" + 258 + "&camp_id=" + camp_ids + "&click_count=1");
  }, []);


  useEffect(() => {
    localStorage.setItem("activetab", "promo");
    var str = localStorage.getItem("lang");
    if (dubai.test(window.location.pathname) == true || uae.test(window.location.pathname) == true) {
      if (str == undefined) {
        str = localStorage.setItem("lang", "en");
      } else {
        console.log("else", str);
        if (str == "en" || str == "ar") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "en");
          str = "en";
        }
      }

      var getnumber = window.location.search.split("?");
      if (getnumber.length > 1) {
        var url = new URL(window.location.href);
        var plans = url.searchParams.get("plan");
        var aff_ids = url.searchParams.get("aff_id");
        var click_ids = url.searchParams.get("click_id");
        var camp_ids = url.searchParams.get("camp_id");
        setplan(plans);
        if (plans == "weekly") {
          localStorage.setItem("plan", "weekly");
        } else {
          localStorage.setItem("plan", "daily");
        }
        checkActiveEffId(aff_ids);
        setaff_id(aff_ids);
        setclick_id(click_ids);
        setcamp_id(camp_ids);
        setoperator_id(258);
      }

      setcheckflow(false);
      setcgflow(false);
    } else if (zong.test(window.location.pathname) == true) {
      console.log("in", str);
      if (str == undefined) {
        str = localStorage.setItem("lang", "zoen");
      } else {
        console.log("else", str);
        if (str == "zoen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "zoen");
          str = "zoen";
        }
      }

      var getnumber = window.location.search.split("?");
      if (getnumber.length > 1) {
        var url = new URL(window.location.href);
        var plans = url.searchParams.get("plan");
        var aff_ids = url.searchParams.get("aff_id");
        var click_ids = url.searchParams.get("click_id");
        var camp_ids = url.searchParams.get("camp_id");
        setplan(plans);
        if (plans == "weekly") {
          localStorage.setItem("plan", "weekly");
        } else {
          localStorage.setItem("plan", "daily");
        }
        setaff_id(aff_ids);
        setclick_id(click_ids);
        setcamp_id(camp_ids);
        setoperator_id(258);
      }

      setcheckflow(false);
      setcgflow(false);
    } else if (grameen.test(window.location.pathname) == true) {
      console.log("in", str);
      if (str == undefined) {
        str = localStorage.setItem("lang", "en_gr");
      } else {
        console.log("else", str);
        if (str == "en_gr") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "en_gr");
          str = "en_gr";
        }
      }
      // var getnumber = window.location.search.split('?')
      var url = new URL(window.location.href);
      var plans = url.searchParams.get("plan");
      // var aff_ids = url.searchParams.get('aff_id')
      // var click_ids = url.searchParams.get('click_id')
      // var camp_ids = url.searchParams.get('camp_id')
      setplan(plans);
      if (window.location.search == "") {
        setcheckflow(true);
        setcgflow(false);
      } else {
        var getnumber = window.location.search.split("=");
        console.log(getnumber);
        if (getnumber[0] == "?plan") {
          console.log("in", str);
          setoperator_id(258);
          if (/daily/i.test(getnumber[1]) == true) {
            var strssssssssss = "skysport_" + getnumber[1];
            localStorage.setItem("plan", "daily");
            setserviceno(strssssssssss);
            setcheckflow(true);
            setcgflow(false);
          }
          if (/weekly/i.test(getnumber[1]) == true) {
            var strssssssssss = "skysport_" + getnumber[1];
            localStorage.setItem("plan", "weekly");
            setserviceno(strssssssssss);
            setcheckflow(true);
            setcgflow(false);
          }
          var strs = getnumber[2].split("&");
          setaff_id(parseInt(strs[0]));
          localStorage.setItem("aff_id", url.searchParams.get("aff_id"));
          //var bMsisdn = url.searchParams.get('aff_id')
          var strss = getnumber[3].split("&");
          setclick_id(strss[0]);
          console.log(getnumber, strss[0]);
          setcamp_id(parseInt(getnumber[4]));
        }
        if (getnumber[0] == "?msisdn") {
          setoperator_id(258);
          if (getnumber[1] == "") {
            completecgflow();
            setcheckflow(false);
            setcgflow(true);
            /*setcheckflow(false)
                setcgflow(false)*/
          } else {
            completecgflow();
            setcheckflow(false);
            setcgflow(true);
          }
        }
      }
      // if(plans == "weekly"){
      //   localStorage.setItem("plan","weekly")
      // }else{
      //   localStorage.setItem("plan","daily")
      // }
      // setaff_id(aff_ids)
      // setclick_id(click_ids)
      // setcamp_id(camp_ids)
      // setcheckflow(false)
      // setcgflow(false)
    } else if (tmobile.test(window.location.pathname) == true) {
      console.log("in", str);
      if (str == undefined) {
        str = localStorage.setItem("lang", "plten");
      } else {
        if (str == "plten") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "plten");
          str = "plten";
        }
      }

      var getnumber = window.location.search.split("?");
      if (getnumber.length > 1) {
        var url = new URL(window.location.href);
        var plans = url.searchParams.get("plan");
        var aff_ids = url.searchParams.get("aff_id");
        var click_ids = url.searchParams.get("click_id");
        var camp_ids = url.searchParams.get("camp_id");
        setplan(plans);
        if (plans == "weekly") {
          localStorage.setItem("plan", "weekly");
        } else {
          localStorage.setItem("plan", "daily");
        }
        setaff_id(aff_ids);
        setclick_id(click_ids);
        setcamp_id(camp_ids);
      }

      setcheckflow(false);
      setcgflow(false);
    } else if (orange.test(window.location.pathname) == true) {
      console.log("in", str);
      //ploen
      if (str == undefined) {
        str = localStorage.setItem("lang", "ploen");
        var getnumber = window.location.search.split("?");
        var burl = new URL(window.location.href);
        var urlAff_id = burl.searchParams.get("aff_id");
        var click_ids = burl.searchParams.get("click_id");
        var camp_ids = burl.searchParams.get("camp_id");
        localStorage.setItem("aff_id", urlAff_id);
        localStorage.setItem("click_id", click_ids);
        localStorage.setItem("camp_id", camp_ids);
        if (getnumber.length > 1) {
          setoperator_id(258);
          var chnages = getnumber[1].split("&");
          var strssssss = chnages[0].split("=");
          setplan(strssssss[1]);
          localStorage.setItem("plan", "daily");
          var strs = chnages[1].split("=");
          setaff_id(parseInt(strs[1]));

          var strss = chnages[2].split("=");
          setclick_id(strss[1]);
          var strsss = chnages[3].split("=");
          setcamp_id(parseInt(strsss[1]));
          console.log("tye in");
          if (chnages.length > 4) {
            console.log(chnages.length);
            var wifi = chnages[4].split("=");
            if (wifi[1] == "no") {
              setcheckflow(true);
              setcgflow(false);
            } else {
              setcheckflow(false);
              setcgflow(false);
            }
          } else {
            console.log("tye in");
            setcheckflow(true);
            setcgflow(false);
          }
        }
      } else {
        if (str == "ploen" || str == "ploen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "ploen");
          str = "ploen";
        }
        var getnumber = window.location.search.split("?");
        if (getnumber.length > 1) {
          setoperator_id(258);
          var burl = new URL(window.location.href);
          var bMsisdn = burl.searchParams.get("dMsisdn");
          var urlAff_id = burl.searchParams.get("aff_id");
          var click_ids = burl.searchParams.get("click_id");
          var camp_ids = burl.searchParams.get("camp_id");
          if (urlAff_id != null && urlAff_id != undefined && urlAff_id != "") {
            localStorage.setItem("aff_id", urlAff_id);
          }
          if (click_ids != null && click_ids != undefined && click_ids != "") {
            localStorage.setItem("click_id", click_ids);
          }
          if (camp_ids != null && camp_ids != undefined && camp_ids != "") {
            localStorage.setItem("camp_id", camp_ids);
          }

          if (bMsisdn != null && bMsisdn != undefined && bMsisdn != "") {
            localStorage.setItem("bmsisdn", bMsisdn);
            setcheckflow(true);
            setcgflow(false);
          } else {
            var chnages = getnumber[1].split("&");
            var strssssss = chnages[0].split("=");
            setplan(strssssss[1]);
            localStorage.setItem("plan", "daily");
            var strs = chnages[1].split("=");
            setaff_id(parseInt(strs[1]));
            var strss = chnages[2].split("=");
            setclick_id(strss[1]);
            var strsss = chnages[3].split("=");
            setcamp_id(parseInt(strsss[1]));
            if (chnages.length > 4) {
              console.log(chnages.length);
              var wifi = chnages[4].split("=");

              if (wifi[1] == "no") {
                setcheckflow(true);
                setcgflow(false);
              } else {
                setcheckflow(false);
                setcgflow(false);
              }
            } else {
              console.log("tye in");
              setcheckflow(true);
              setcgflow(false);
            }
          }
        }
      }
    } else if (sierra.test(window.location.pathname) == true) {
      //oslen
      if (str == undefined) {
        str = localStorage.setItem("lang", "oslen");
        var getnumber = window.location.search.split("?");
        var burl = new URL(window.location.href);
        var urlAff_id = burl.searchParams.get("aff_id");
        var click_ids = burl.searchParams.get("click_id");
        var camp_ids = burl.searchParams.get("camp_id");
        var plan = burl.searchParams.get("plan");
        localStorage.setItem("aff_id", urlAff_id);
        localStorage.setItem("click_id", click_ids);
        localStorage.setItem("camp_id", camp_ids);
        if (getnumber.length > 1) {
          setoperator_id(258);
          var chnages = getnumber[1].split("&");
          var strssssss = chnages[0].split("=");
          setplan(plan);
          localStorage.setItem("plan", plan);
          var strs = chnages[1].split("=");
          setaff_id(parseInt(strs[1]));

          var strss = chnages[2].split("=");
          setclick_id(strss[1]);
          var strsss = chnages[3].split("=");
          setcamp_id(parseInt(strsss[1]));
          console.log("tye in");
          if (chnages.length > 4) {
            console.log(chnages.length);
            var wifi = chnages[4].split("=");
            if (wifi[1] == "no") {
              setcheckflow(true);
              setcgflow(false);
            } else {
              setcheckflow(false);
              setcgflow(false);
            }
          } else {
            console.log("tye in");
            setcheckflow(true);
            setcgflow(false);
          }
        }
      } else {
        if (str == "oslen" || str == "oslen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "oslen");
          str = "oslen";
        }
        /**
         *   var burl = new URL(window.location.href)
        var bMsisdn = burl.searchParams.get('dMsisdn') 
        if(bMsisdn){
            console.log(bMsisdn);
        } 
         */
        var getnumber = window.location.search.split("?");
        if (getnumber.length > 1) {
          setoperator_id(258);
          var burl = new URL(window.location.href);
          var bMsisdn = burl.searchParams.get("dMsisdn");
          var urlAff_id = burl.searchParams.get("aff_id");
          var click_ids = burl.searchParams.get("click_id");
          var camp_ids = burl.searchParams.get("camp_id");
          if (urlAff_id != null && urlAff_id != undefined && urlAff_id != "") {
            localStorage.setItem("aff_id", urlAff_id);
          }
          if (click_ids != null && click_ids != undefined && click_ids != "") {
            localStorage.setItem("click_id", click_ids);
          }
          if (camp_ids != null && camp_ids != undefined && camp_ids != "") {
            localStorage.setItem("camp_id", camp_ids);
          }

          if (bMsisdn != null && bMsisdn != undefined && bMsisdn != "") {
            localStorage.setItem("bmsisdn", bMsisdn);
            setcheckflow(true);
            setcgflow(false);
          } else {
            var chnages = getnumber[1].split("&");
            var strssssss = chnages[0].split("=");
            setplan(strssssss[1]);
            localStorage.setItem("plan", strssssss[1]);
            var strs = chnages[1].split("=");
            setaff_id(parseInt(strs[1]));
            var strss = chnages[2].split("=");
            setclick_id(strss[1]);
            var strsss = chnages[3].split("=");
            setcamp_id(parseInt(strsss[1]));
            if (chnages.length > 4) {
              console.log(chnages.length);
              var wifi = chnages[4].split("=");

              if (wifi[1] == "no") {
                setcheckflow(true);
                setcgflow(false);
              } else {
                setcheckflow(false);
                setcgflow(false);
              }
            } else {
              console.log("tye in");
              setcheckflow(true);
              setcgflow(false);
            }
          }
        }
      }
    } else if (play.test(window.location.pathname) == true) {
      console.log("in", str);
      if (str == undefined) {
        str = localStorage.setItem("lang", "plpen");
      } else {
        if (str == "plpen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "plpen");
          str = "plpen";
        }
      }

      var getnumber = window.location.search.split("?");
      if (getnumber.length > 1) {
        var url = new URL(window.location.href);
        var plans = url.searchParams.get("plan");
        var aff_ids = url.searchParams.get("aff_id");
        var click_ids = url.searchParams.get("click_id");
        var camp_ids = url.searchParams.get("camp_id");
        setplan(plans);
        if (plans == "weekly") {
          localStorage.setItem("plan", "weekly");
        } else {
          localStorage.setItem("plan", "daily");
        }
        setaff_id(aff_ids);
        setclick_id(click_ids);
        setcamp_id(camp_ids);
      }

      setcheckflow(false);
      setcgflow(false);
    } else if (plus.test(window.location.pathname) == true) {
      console.log("in", str);
      if (str == undefined) {
        str = localStorage.setItem("lang", "plppen");
      } else {
        if (str == "plppen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "plppen");
          str = "plppen";
        }
      }

      var getnumber = window.location.search.split("?");
      if (getnumber.length > 1) {
        var url = new URL(window.location.href);
        var plans = url.searchParams.get("plan");
        var aff_ids = url.searchParams.get("aff_id");
        var click_ids = url.searchParams.get("click_id");
        var camp_ids = url.searchParams.get("camp_id");
        setplan(plans);
        if (plans == "weekly") {
          localStorage.setItem("plan", "weekly");
        } else {
          localStorage.setItem("plan", "daily");
        }
        setaff_id(aff_ids);
        setclick_id(click_ids);
        setcamp_id(camp_ids);
      }

      setcheckflow(false);
      setcgflow(false);
    } else if (virgin.test(window.location.pathname) == true) {
      var getnumber = window.location.search.split("?");
      if (str == undefined) {
        str = localStorage.setItem("lang", "ven");
      } else {
        if (str == "ven" || str == "var") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "ven");
          str = "ven";
        }
        // var getnumber = window.location.search.split('?')
        // if(getnumber.length > 1) {
        //   var chnages = getnumber[1].split('&')
        //   var strs = chnages[0].split('=')
        //   setplan(strs[1])
        //   localStorage.setItem("plan",'daily')
        //   var strs = chnages[1].split('=')
        //   console.log("strs[1]:"+strs[1])
        //   setaff_id(parseInt(strs[1]))
        //   var strss = chnages[2].split('=')
        //   setclick_id(parseInt(strss[1]))
        // }
      }
      if (getnumber.length > 1) {
        var chnages = getnumber[1].split("&");
        var strs = chnages[0].split("=");
        if (strs[0] == "ref") {
          setoperator_id(258);
          var plans = strs[1].split("_");
          setplan(plans[0]);
          setaff_id(plans[1]);
          setclick_id(plans[2]);
          setcamp_id(plans[3]);
          var msisdn = chnages[2].split("=");
          getphone(msisdn[1]);
          getphones(msisdn[1]);
          localStorage.setItem("update", "0");
          var gettime = new Date();
          var veriftotpurlreq =
            virgin.test(window.location.pathname) == false || phones == ""
              ? gettime +
                "| REQ |" +
                conuty +
                phone +
                "|" +
                myConfig.billing_url +
                "subscription.php" +
                "| POST Parameters =>" +
                window.location.search
              : gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + window.location.search;
          var finalobj9 = {
            security: "col#c4",
            logData: veriftotpurlreq,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj9);

          axios.post(myConfig.billing_url + "stagingCount.php?aff_id=" + plans[1] + "&operator_id=" + 258 + "&auto_detect_mobile_count=1");

          var veriftotpurlreq =
            virgin.test(window.location.pathname) == false || phones == ""
              ? gettime +
                "| REQ |" +
                conuty +
                phone +
                "|" +
                myConfig.billing_url +
                "stagingCount.php" +
                "| POST Parameters =>" +
                "aff_id=" +
                plans[1] +
                "&operator_id=" +
                258 +
                "&auto_detect_mobile_count=1"
              : gettime +
                "| REQ |" +
                phone +
                "|" +
                myConfig.billing_url +
                "stagingCount.php" +
                "| POST Parameters =>" +
                "aff_id=" +
                plans[1] +
                "&operator_id=" +
                258 +
                "&auto_detect_mobile_count=1";
          var finalobj21 = {
            security: "col#c4",
            logData: veriftotpurlreq,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj21);
        } 
        // else if (strs[0] == "plan") {
        //   setoperator_id(258);
        //   setplan(strs[1]);
        //   localStorage.setItem("plan", "daily");
        //   var strs = chnages[1].split("=");
        //   console.log("strs[1]:" + strs[1]);
        //   setaff_id(parseInt(strs[1]));
        //   localStorage.setItem("aff_id", parseInt(strs[1]));
        //   var strss = chnages[2].split("=");
        //   setclick_id(strss[1]);
        //   localStorage.setItem("click_id", strss[1]);
        //   var strsss = chnages[3]?.split("=");
        //   setcamp_id(parseInt(strsss?.[1]));
        //   localStorage.setItem("camp_id", parseInt(strsss?.[1]));
        //   setIsUpdate(true);
        //   //localStorage.setItem("update",'1')
        // }
      //   else if (strs[0] == "plan") {
      //     setoperator_id(258);
      //     setplan(strs[1]);
      //     localStorage.setItem("plan", "daily");
      
      //     // Process aff_id
      //     var strs = chnages[1].split("=");
      //     console.log("strs[1]:" + strs[1]);
      //     setaff_id(parseInt(strs[1]));
      //     localStorage.setItem("aff_id", parseInt(strs[1]));
      
      //     // Process click_id and camp_id correctly
      //     var strss = chnages[2].split("="); // Extract click_id and camp_id
      //     var clickCamp = strss[1].split("$"); // Split '1234$camp_id'
      //     setclick_id(clickCamp[0]); // '1234'
      //     localStorage.setItem("click_id", clickCamp[0]); // Store '1234'
      
      //     var campParts = clickCamp[1].split("camp_id="); // Extract '2' from 'camp_id=2'
      //     setcamp_id(parseInt(campParts[1])); // '2'
      //     localStorage.setItem("camp_id", parseInt(campParts[1])); // Store '2'
      
      //     setIsUpdate(true);
      // }
      else if (strs[0] == "plan") {
        // Set operator ID and plan
        setoperator_id(258);
        setplan(strs[1]);
        localStorage.setItem("plan", "daily");
    
        // Process aff_id
        var affStr = chnages[1].split("="); // ["aff_id", "1003"]
        console.log("aff_id:" + affStr[1]);
        setaff_id(parseInt(affStr[1])); // 1003
        localStorage.setItem("aff_id", parseInt(affStr[1])); // Store 1003
    
        // Process click_id
        var clickStr = chnages[2].split("="); // ["click_id", "1234"]
        console.log("click_id:" + clickStr[1]);
        setclick_id(clickStr[1]); // 1234
        localStorage.setItem("click_id", clickStr[1]); // Store 1234
    
        // Process camp_id
        var campStr = chnages[3].split("="); // ["camp_id", "2"]
        console.log("camp_id:" + campStr[1]);
        setcamp_id(parseInt(campStr[1])); // 2
        localStorage.setItem("camp_id", parseInt(campStr[1])); // Store 2
    
        // Update state
        setIsUpdate(true);
    }
    
      }

      setcheckflow(false);
      setcgflow(false);
    } else if (voda.test(window.location.pathname) == true) {
      if (str == undefined) {
        str = localStorage.setItem("lang", "voen");
        // var getnumber = window.location.search.split('=')
        // console.log(getnumber);
        // if (window.location.search == '') {
        //   setserviceno("skysport_daily")
        //   localStorage.setItem("plan","daily")
        //   setcheckflow(true)
        //   console.log("yes")
        //   setcgflow(false)
        // }else {
        //   console.log("in")
        //     if(getnumber[0] == "?plan") {
        //       if (/daily/i.test(getnumber[1]) == true) {
        //         var strssssssssss = "skysport_" + getnumber[1]
        //         localStorage.setItem("plan","daily")
        //         setserviceno(strssssssssss)
        //         setcheckflow(true)
        //         setcgflow(false)
        //       }
        //       if (/weekly/i.test(getnumber[1]) == true) {
        //         var strssssssssss = "skysport_" + getnumber[1]
        //         localStorage.setItem("plan","weekly")
        //         setserviceno(strssssssssss)
        //         setcheckflow(true)
        //         setcgflow(false)
        //       }

        //     }
        //     if (getnumber[0] == "?msisdn") {
        //       if (getnumber[1] == '') {
        //         completecgflow()
        //         setcheckflow(false)
        //         setcgflow(true)
        //         /*setcheckflow(false)
        //         setcgflow(false)*/
        //       }else {
        //         completecgflow()
        //         setcheckflow(false)
        //         setcgflow(true)
        //       }
        //     }
        //   }
      } else {
        if (str == "voen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "voen");
          str = "voen";
        }
      }
      if (window.location.search == "") {
        // setserviceno("skysport_daily")
        // localStorage.setItem("plan","daily")
        setcheckflow(true);
        // console.log("yes")
        setcgflow(false);
      } else {
        var getnumber = window.location.search.split("=");
        console.log("voad watara");
        if (getnumber[0] == "?plan") {
          setoperator_id(258);
          if (/daily/i.test(getnumber[1]) == true) {
            var strssssssssss = "skysport_" + getnumber[1];
            localStorage.setItem("plan", "daily");
            setserviceno(strssssssssss);
            setcheckflow(true);
            setcgflow(false);
          }
          if (/weekly/i.test(getnumber[1]) == true) {
            var strssssssssss = "skysport_" + getnumber[1];
            localStorage.setItem("plan", "weekly");
            setserviceno(strssssssssss);
            setcheckflow(true);
            setcgflow(false);
          }
          var strs = getnumber[2].split("&");
          setaff_id(parseInt(strs[0]));
          var strss = getnumber[3].split("&");
          setclick_id(strss[0]);
          console.log(getnumber, strss[0]);
          setcamp_id(parseInt(getnumber[4]));
        }
        if (getnumber[0] == "?msisdn") {
          setoperator_id(258);
          if (getnumber[1] == "") {
            completecgflow();
            setcheckflow(false);
            setcgflow(true);
            /*setcheckflow(false)
                setcgflow(false)*/
          } else {
            completecgflow();
            setcheckflow(false);
            setcgflow(true);
          }
        }
      }
    } else if (beeline.test(window.location.pathname) == true) {
      if (str == undefined) {
        str = localStorage.setItem("lang", "boar");
        var getnumber = window.location.search.split("?");
        var burl = new URL(window.location.href);
        var urlAff_id = burl.searchParams.get("aff_id");
        var click_ids = burl.searchParams.get("click_id");
        var camp_ids = burl.searchParams.get("camp_id");
        localStorage.setItem("aff_id", urlAff_id);
        localStorage.setItem("click_id", click_ids);
        localStorage.setItem("camp_id", camp_ids);
        if (getnumber.length > 1) {
          setoperator_id(258);
          var chnages = getnumber[1].split("&");
          var strssssss = chnages[0].split("=");
          setplan(strssssss[1]);
          localStorage.setItem("plan", "daily");
          var strs = chnages[1].split("=");
          setaff_id(parseInt(strs[1]));

          var strss = chnages[2].split("=");
          setclick_id(strss[1]);
          var strsss = chnages[3].split("=");
          setcamp_id(parseInt(strsss[1]));
          console.log("tye in");
          if (chnages.length > 4) {
            console.log(chnages.length);
            var wifi = chnages[4].split("=");
            if (wifi[1] == "no") {
              setcheckflow(true);
              setcgflow(false);
            } else {
              setcheckflow(false);
              setcgflow(false);
            }
          } else {
            console.log("tye in");
            setcheckflow(true);
            setcgflow(false);
          }
        }
      } else {
        if (str == "boar" || str == "boen") {
          str = localStorage.getItem("lang");
        } else {
          localStorage.setItem("lang", "boar");
          str = "boar";
        }
        /**
         *   var burl = new URL(window.location.href)
        var bMsisdn = burl.searchParams.get('dMsisdn') 
        if(bMsisdn){
            console.log(bMsisdn);
        } 
         */
        var getnumber = window.location.search.split("?");
        if (getnumber.length > 1) {
          setoperator_id(258);
          var burl = new URL(window.location.href);
          var bMsisdn = burl.searchParams.get("dMsisdn");
          var urlAff_id = burl.searchParams.get("aff_id");
          var click_ids = burl.searchParams.get("click_id");
          var camp_ids = burl.searchParams.get("camp_id");
          if (urlAff_id != null && urlAff_id != undefined && urlAff_id != "") {
            localStorage.setItem("aff_id", urlAff_id);
          }
          if (click_ids != null && click_ids != undefined && click_ids != "") {
            localStorage.setItem("click_id", click_ids);
          }
          if (camp_ids != null && camp_ids != undefined && camp_ids != "") {
            localStorage.setItem("camp_id", camp_ids);
          }

          if (bMsisdn != null && bMsisdn != undefined && bMsisdn != "") {
            localStorage.setItem("bmsisdn", bMsisdn);
            setcheckflow(true);
            setcgflow(false);
          } else {
            var chnages = getnumber[1].split("&");
            var strssssss = chnages[0].split("=");
            setplan(strssssss[1]);
            localStorage.setItem("plan", "daily");
            var strs = chnages[1].split("=");
            setaff_id(parseInt(strs[1]));
            var strss = chnages[2].split("=");
            setclick_id(strss[1]);
            var strsss = chnages[3].split("=");
            setcamp_id(parseInt(strsss[1]));
            if (chnages.length > 4) {
              console.log(chnages.length);
              var wifi = chnages[4].split("=");

              if (wifi[1] == "no") {
                setcheckflow(true);
                setcgflow(false);
              } else {
                setcheckflow(false);
                setcgflow(false);
              }
            } else {
              console.log("tye in");
              setcheckflow(true);
              setcgflow(false);
            }
          }
        }
      }
      // setcheckflow(false)
      // setcgflow(false)
    }

    // console.log("en", str);
    if (str == "en") {
      console.log("en");
      setlan(lang.en);
    } else if (str == "zoen") {
      setlan(lang.zoen);
    } else if (str == "ar") {
      setlan(lang.ar);
    } else if (str == "var") {
      setlan(lang.var);
    } else if (str == "ven") {
      setlan(lang.ven);
    } else if (str == "voen") {
      setlan(lang.voen);
    } else if (str == "boen") {
      setlan(lang.boen);
    } else if (str == "boar") {
      setlan(lang.boar);
    } else if (str == "plten") {
      setlan(lang.plten);
    } else if (str == "ploen") {
      setlan(lang.ploen);
    } else if (str == "oslen") {
      setlan(lang.oslen);
    } else if (str == "plpen") {
      setlan(lang.plpen);
    } else if (str == "plppen") {
      setlan(lang.plppen);
    } else if (str == "en_gr") {
      setlan(lang.en_gr);
    }
  });

  useEffect(() => {
    var countryCodes;

    if (
      dubai.test(window.location.pathname) == true ||
      uae.test(window.location.pathname) == true ||
      zong.test(window.location.pathname) == true ||
      virgin.test(window.location.pathname) == true ||
      voda.test(window.location.pathname) == true ||
      beeline.test(window.location.pathname) == true ||
      tmobile.test(window.location.pathname) == true ||
      orange.test(window.location.pathname) == true ||
      sierra.test(window.location.pathname) == true ||
      play.test(window.location.pathname) == true ||
      plus.test(window.location.pathname) == true ||
      grameen.test(window.location.pathname) == true
    ) {
      console.log("in here");
      const fetchDatas = async () => {
        var str = window.location.pathname;
        const dataes = codeJson.filter((i) => i.link === str);
        console.log("dataes", dataes);
        if (dataes.length > 0) {
          window.sessionStorage.setItem("path", dataes[0].link);
          window.sessionStorage.setItem("dialCode", dataes[0].dial_code.slice(1));

          getcountry(dataes[0].dial_code.slice(1));
          getcountrys("+" + dataes[0].dial_code.slice(1));
          history.push(window.location.pathname);
        } else {
          history.push("/notfound");
        }
        const dataArrays = codeJson.filter((i) => i.link === str);
        setproductdetails(dataArrays[0]);
      };
      fetchDatas();
    } else {
      console.log("else here");
      const fetchData = async () => {
        const result = await axios(myConfig.billing_url + "countryCode.php");
        //http://13.126.46.199:8080/ssn/contentDetailBySubcategoryNCategory/?categoryId=1&subcategoryId=1&contentId=1&contrycode=91
        window.sessionStorage.setItem("sCountryCode", result.data.geoplugin_countryCode);
        setuserip(result.data.geoplugin_request);
        var str = window.location.pathname;
        const dataes = codeJson.filter((i) => i.link === str);
        console.log("dataes", dataes);
        if (dataes.length > 0) {
          window.sessionStorage.setItem("path", dataes[0].link);
          history.push(window.location.pathname);
        } else {
          history.push("/notfound");
        }

        // old code set code 91 bcz not match to windolw url
        const dataArray = codeJson.filter((i) => i.code === result.data.geoplugin_countryCode);

        // set new condition for matching link to window url set 965 code
        // const dataArray = codeJson.filter((i) => i.link === str);
        console.log(dataArray);
        if (dataArray.length > 0) {
          // setproductdetails(dataArray[0])
          window.sessionStorage.setItem("dialCode", dataArray[0].dial_code.slice(1));

          getcountry(dataArray[0].dial_code.slice(1));
          getcountrys("+" + dataArray[0].dial_code.slice(1));
        }

        const dataArrays = codeJson.filter((i) => i.link === str);
        setproductdetails(dataArrays[0]);
      };
      fetchData();
    }

    // localStorage.removeItem("lang")

    var browser = (function () {
      var test = function (regexp) {
        return regexp.test(window.navigator.userAgent);
      };
      switch (true) {
        case test(/edg/i):
          return "Microsoft Edge";
        case test(/trident/i):
          return "Microsoft Internet Explorer";
        case test(/firefox|fxios/i):
          return "Mozilla Firefox";
        case test(/opr\//i):
          return "Opera";
        case test(/ucbrowser/i):
          return "UC Browser";
        case test(/samsungbrowser/i):
          return "Samsung Browser";
        case test(/chrome|chromium|crios/i):
          return "Google Chrome";
        case test(/safari/i):
          return "Apple Safari";
        default:
          return "Other";
      }
    })();
    setbrowser(browser);

    if (voda.test(window.location.pathname) == true) {
      setInterval(() => {
        $("#subscribeMsisdn").show();
        $("#verify").hide();
      }, 1000);
      return;
    }
    $("#subscribeMsisdn").show();
    $("#verify").hide();
  }, []);

  useEffect(() => {
    if (virgin.test(window.location.pathname) == true) {
      if (localStorage.getItem("update") == "1") {
        var str =
          localStorage.getItem("plan") +
          "_" +
          localStorage.getItem("aff_id") +
          "_" +
          localStorage.getItem("click_id") +
          "_" +
          localStorage.getItem("camp_id") +
          "_" +
          Math.floor(1000 + Math.random() * 9000);
        console.log(str);
        // window.location.href =
        //   "http://sdp.altruistindia.com:8080/reports/header.php?UserName=IbuDigital&Password=d5ba5e842aace15863f3c34eda86251e&Ref=" + str;
      }
    }
  }, [localStorage.getItem("click_id") != null ? localStorage.getItem("click_id") : ""]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios(myConfig.server_url + "listAllFAQ/", {
        headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
      });
      //http://13.126.46.199:8080/ssn/contentDetailBySubcategoryNCategory/?categoryId=1&subcategoryId=1&contentId=1&contrycode=91
      setFaqs(result.data.listData);
    };
    fetchData();
    const dataArray = codeJson.filter((i) => i.code === window.sessionStorage.getItem("sCountryCode"));
  }, []);

  const checknumber = (e) => {
    if (e.target.value.length > 0) {
      getphone(e.target.value);
      $("#msisdn").removeClass("buttondis");
    } else {
      getphone(e.target.value);
      $("#msisdn").addClass("buttondis");
    }
  };

  const checkotp = (e) => {
    // console.log(e.target.value.length);
    if (e.target.value.length == 4) {
      getotp(e.target.value);
      $("#msisdn").removeClass("buttondis");
    } else {
      getotp(e.target.value);
      $("#msisdn").addClass("buttondis");
    }
  };

  const chnagecountrycode = (e) => {
    getcountry(e.target.value);
  };

  const verifyotp = () => {
    var dial_code = window.sessionStorage.getItem("dialCode");
    console.log(dial_code);
    if (otp != "undefined") {
      if (beeline.test(window.location.pathname) == true || sierra.test(window.location.pathname) == true) {
        if (otp.length == 5) {
          if (camp_id === NaN) {
            camp_id = 3;
          }
          var otpurl =
            myConfig.billing_url +
            "subscription.php?affiliate=" +
            aff_id +
            "&cg_image_url=&mode=WAP&msisdn=" +
            conuty +
            phone +
            "&product_id=" +
            productdetails.product_id +
            "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id=" +
            aff_id +
            "&camp_id=" +
            camp_id +
            "&other1=verify_otp&other2=" +
            otp;
          var queryparams =
            "affiliate = " +
            aff_id +
            " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
            conuty +
            phone +
            "| product_id = " +
            productdetails.product_id +
            "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 = verify_otp | other2 = " +
            otp;
          var gettime = new Date();
          var veriftotpurlreq =
            gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
          var finalobj9 = {
            security: "col#c4",
            logData: veriftotpurlreq,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj9);
          axios.get(otpurl).then((Response) => {
            var obj = {
              status: Response.data.status,
              ip: browser,
              agent: navigator.userAgent,
              response: Response,
              mobile_no: conuty + phone,
              productdetails: productdetails.product_id,
            };
            var obje = JSON.stringify(obj);
            var finalobj = {
              security: "col#c4",
              logData: obje,
            };
            var gettime = new Date();
            var queryparams1 =
              "affiliate=" +
              aff_id +
              "&cg_image_url=&mode=WAP&msisdn=" +
              conuty +
              phone +
              "&product_id=" +
              productdetails.product_id +
              "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2=" +
              otp;
            var veriftotpurlres =
              gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
            var finalobj5 = {
              security: "col#c4",
              logData: veriftotpurlres,
            };
            axios.post(myConfig.billing_url + "appLog.php", finalobj5);
            var createanotherurl =
              gettime +
              "|" +
              conuty +
              phone +
              "|" +
              window.location.pathname +
              "|" +
              1111 +
              "|" +
              browser +
              "|" +
              222222 +
              "|" +
              111111 +
              "|" +
              navigator.userAgent +
              "|" +
              otpurl +
              "|" +
              JSON.stringify(Response);
            var finalobj6 = {
              security: "col#c4",
              logData: createanotherurl,
            };
            axios.post(myConfig.billing_url + "visitorLog.php", finalobj6);

            if (Response.data.status == "OK") {
              // history.push('/thankYou')
              const result = axios(myConfig.server_url + "checkUser/" + conuty + phone, {
                headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
              }).then((res) => {
                console.log(res);
                if (res.data == false) {
                  var addsub = {
                    countryCode: conuty,
                    emailId: "string",
                    loginType: "mobile",
                    name: "",
                    phoneNumber: conuty + phone,
                    userId: conuty + phone,
                  };
                  axios
                    .post(myConfig.server_url + "user/", addsub, {
                      headers: {
                        Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                        "X-Content-Type-Options": "nosniff",
                      },
                    })
                    .then((Response) => {
                      axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 258 + "&msisdn=" + conuty + phone);
                      window.sessionStorage.setItem("userId", conuty + phone);
                      $("#verify").hide();
                      $("#mobotp5").hide();
                      history.push("/welcome");
                    });
                } else {
                  const result = axios(myConfig.server_url + "getSubscribedUser/" + conuty + phone, {
                    headers: {
                      Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                      "X-Content-Type-Options": "nosniff",
                    },
                  }).then((resp) => {
                    axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 258 + "&msisdn=" + conuty + phone);
                    window.sessionStorage.setItem("userId", conuty + phone);
                    localStorage.setItem("name", resp.data.name);
                    window.sessionStorage.setItem("isLogin", true);
                    $("#verify").hide();
                    $("#mobotp5").hide();
                    history.push("/welcome");
                  });
                }
              });
              // // return  console.log(result)
              //     $('#verify').hide()
              //     $("#mobotp").hide()
            } else {
              history.push("/fail");
            }
          });
        } else {
          $("#mobotp5").show();
        }
      } else {
        if (otp.length == 4) {
          var otpurl =
            virgin.test(window.location.pathname) == false || phones == ""
              ? myConfig.billing_url +
                "subscription.php?affiliate=" +
                aff_id +
                "&msisdn=" +
                conuty +
                // 965+
                phone +
                "&product_id=SEVdbkwzaindly&uniqueId=" +
                // productdetails.product_id +
                TransID+
                "&antifrauduniqid="+
                otpAcrValue+
               
                "&other1=verify_otp&other2=" +
                otp +
                "&plan="+
                plan+
                "&aff_id="+
                aff_id+
                "&aff_uniq_id="+
                click_id+
                "&camp_id=" +
                camp_id 
               
              : myConfig.billing_url +
              "subscription.php?affiliate=" +
              aff_id +
              "&msisdn=" +
              conuty +
              phone +
              "&product_id=SEVdbkwzaindly&uniqueId=" +
              // productdetails.product_id +
              TransID+
              "&antifrauduniqid="+
              otpAcrValue+
             
              "&other1=verify_otp&other2=" +
              otp +
              "&plan="+
              plan+
              "&aff_id="+
              aff_id+
              "&aff_uniq_id="+
              click_id+
              "&camp_id=" +
              camp_id;
              // myConfig.billing_url +
              //   "subscription.php?affiliate=" +
              //   aff_id +
              //   "&cg_image_url=&mode=WAP&msisdn=" +
              //   phone +
              //   "&product_id=" +
              //   productdetails.product_id +
              //   "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2="  +
               
                
              //   otp ;
              
          var queryparams =
            virgin.test(window.location.pathname) == false || phones == ""
              ? "affiliate = " +
                aff_id +
                " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
                conuty +
                phone +
                "| product_id = " +
                productdetails.product_id +
                "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 = verify_otp | other2 = " +
                otp
              : "affiliate = " +
                aff_id +
                " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
                conuty +
                phone +
                "| product_id = " +
                productdetails.product_id +
                "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 = verify_otp | other2 = " +
                otp;
          var gettime = new Date();
          var veriftotpurlreq =
            virgin.test(window.location.pathname) == false || phones == ""
              ? gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams
              : gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
          var finalobj9 = {
            security: "col#c4",
            logData: veriftotpurlreq,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj9);
          axios.get(otpurl).then((Response) => {
            var obj;
            if (virgin.test(window.location.pathname) == false || phones == "") {
              obj = {
                status: Response.data.status,
                ip: browser,
                agent: navigator.userAgent,
                response: Response,
                mobile_no: conuty + phone,
                productdetails: productdetails.product_id,
              };
            } else {
              obj = {
                status: Response.data.status,
                ip: browser,
                agent: navigator.userAgent,
                response: Response,
                mobile_no: conuty + phone,
                productdetails: productdetails.product_id,
              };
            }
            var obje = JSON.stringify(obj);
            var finalobj = {
              security: "col#c4",
              logData: obje,
            };
            var gettime = new Date();
            var queryparams1 =
              "affiliate=" +
              aff_id +
              "&cg_image_url=&mode=WAP&msisdn=" +
              conuty +
              phone +
              "&product_id=" +
              productdetails.product_id +
              "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2=" +
              otp;
            var veriftotpurlres =
              virgin.test(window.location.pathname) == false || phones == ""
                ? gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data)
                : gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
            var finalobj5 = {
              security: "col#c4",
              logData: veriftotpurlres,
            };
            axios.post(myConfig.billing_url + "appLog.php", finalobj5);
            var createanotherurl =
              virgin.test(window.location.pathname) == false || phones == ""
                ? gettime +
                  "|" +
                  conuty +
                  phone +
                  "|" +
                  window.location.pathname +
                  "|" +
                  1111 +
                  "|" +
                  browser +
                  "|" +
                  222222 +
                  "|" +
                  111111 +
                  "|" +
                  navigator.userAgent +
                  "|" +
                  otpurl +
                  "|" +
                  JSON.stringify(Response)
                : gettime +
                  "|" +
                  conuty +
                  phone +
                  "|" +
                  window.location.pathname +
                  "|" +
                  1111 +
                  "|" +
                  browser +
                  "|" +
                  222222 +
                  "|" +
                  111111 +
                  "|" +
                  navigator.userAgent +
                  "|" +
                  otpurl +
                  "|" +
                  JSON.stringify(Response);
            var finalobj6 = {
              security: "col#c4",
              logData: createanotherurl,
            };
            axios.post(myConfig.billing_url + "visitorLog.php", finalobj6);

            if (Response.data.status == "OK") {
              // var otpurl =
              //   virgin.test(window.location.pathname) == false || phones == ""
              //     ? myConfig.billing_url +
              //       "subscription.php?affiliate=" +
              //       aff_id +
              //       "&cg_image_url=&mode=WAP&msisdn=" +
              //       conuty +
              //       phone +
              //       "&product_id=" +
              //       productdetails.product_id +
              //       "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&aff_id=" +
              //       aff_id +
              //       "&camp_id=" +
              //       camp_id +
              //       "&other1=verify_otp&other2=" +
              //       otp
              //     : "http://callback1.skysportsnetwork.com/mpg/subscription.php?" +
              //       aff_id +
              //       "&cg_image_url=&mode=WAP&msisdn=" +
              //       phone +
              //       "&product_id=" +
              //       productdetails.product_id +
              //       "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=verify_otp&other2=" +
              //       otp;

              // var affiliateValue = aff_id;
              // var msisdnValue = conuty + phone;
              // var product_idValue = productdetails.product_id;
              // var camp_idValue = camp_id;
              // var other1Value = "verify_otp";
              // var other2Value = otp;

              // if (acrValue) {
              //   // Construct dynamicUrl with advertidValue and acrValue
              //   const dynamicUrl = `https://callback1.skysportsnetwork.com/mpg/subscription.php?affiliate=${affiliateValue}&msisdn=${msisdnValue}&product_id=${product_idValue}&camp_id=${camp_idValue}&other1=${other1Value}&other2=${other2Value}&advertid=${acrValue}`;

              //   console.log("Constructed URL:", dynamicUrl); // Debugging line

              //   // Make the API call with dynamicUrl
              //   axios
              //     .post(dynamicUrl)
              //     .then((apiResponse) => {
              //       // Check if the status is not 200 (OK)
              //       if (apiResponse.status !== 200) {
              //         console.error("API call failed with status:", apiResponse.status);
              //         history.push("/fail");
              //         return;
              //       }

              //       // Handle the response if needed
              //       console.log(apiResponse.data);
              //     })
              //     .catch((error) => {
              //       // Handle errors
              //       console.error("Error calling subscription API:", error);
              //       history.push("/fail");
              //     });
              // }

              axios(myConfig.server_url + "checkUser/" + conuty + phone, {
                headers: { Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64") },
              }).then((res) => {
                console.log(res);
                if (res.data == false) {
                  var addsub = {
                    countryCode: conuty,
                    emailId: "string",
                    loginType: "mobile",
                    name: "",
                    phoneNumber: conuty + phone,
                    userId: conuty + phone,
                  };
                  axios
                    .post(myConfig.server_url + "user/", addsub, {
                      headers: {
                        Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                        "X-Content-Type-Options": "nosniff",
                      },
                    })
                    .then((response) => {
                      window.sessionStorage.setItem("userId", conuty + phone);
                      axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 258 + "&msisdn=" + conuty + phone);
                      $("#verify").hide();
                      $("#mobotp").hide();
                      history.push("/welcome");
                    });
                } else {
                  axios(myConfig.server_url + "getSubscribedUser/" + conuty + phone, {
                    headers: {
                      Authorization: "Basic " + Buffer.from(`${myConfig.user}:${myConfig.password}`, "utf8").toString("base64"),
                      "X-Content-Type-Options": "nosniff",
                    },
                  }).then((resp) => {
                    window.sessionStorage.setItem("userId", conuty + phone);
                    localStorage.setItem("name", resp.data.name);
                    axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 258 + "&msisdn=" + conuty + phone);
                    window.sessionStorage.setItem("isLogin", true);
                    $("#verify").hide();
                    $("#mobotp").hide();
                    history.push("/welcome");
                  });
                }
              });
            } else {
              history.push("/fail");
            }
          });
        } else {
          $("#mobotp").show();
        }
      }
    } else {
      $("mobotp").show();
    }
  };

  const beline = () => {
    if (sierra.test(window.location.pathname) == true) {
      var gProductId = productdetails.product_id;
      var opcode = 91;
      if (orange.test(window.location.pathname) == true) {
        opcode = 91;
      } else {
        opcode = 100;
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      if (localStorage.getItem("plan") == "daily") {
        gProductId = "SEVdb100dly";
        //gProductId = "SEVdb100wly";
      } else {
        gProductId = "SEVdb100wly";
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var queryparams4 =
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var gettime = new Date();
      var subreq = gettime + "| REQ |" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
      var finalobj4 = {
        security: "col#c4",
        logData: subreq,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj4);
      axios.get(anotherUrl).then((Response) => {
        console.log(Response);
        /*** */
        var obj = {
          status: Response.data.status,
          ip: browser,
          agent: navigator.userAgent,
          response: Response,
          mobile_no: conuty + phone,
          productdetails: productdetails.product_id,
        };
        var obje = JSON.stringify(obj);
        var finalobj = {
          security: "col#c4",
          logData: obje,
        };
        var gettime = new Date();
        var queryparams5 =
          "subscription.php?affiliate=" +
          aff_id +
          "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
          productdetails.product_id +
          "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
        var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
        var finalobj7 = {
          security: "col#c4",
          logData: subros,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj7);
        var createanotherurl =
          gettime +
          "|" +
          conuty +
          phone +
          "|" +
          window.location.pathname +
          "|" +
          1111 +
          "|" +
          browser +
          "|" +
          222222 +
          "|" +
          111111 +
          "|" +
          navigator.userAgent +
          "|" +
          anotherUrl +
          "|" +
          JSON.stringify(Response);
        var finalobj8 = {
          security: "col#c4",
          logData: createanotherurl,
        };
        axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

        if (Response.data.status == "OK") {
          window.open(Response.data.url, "_blank");
          var getMsisdn =
            myConfig.billing_url +
            "subscription.php?affiliate=" +
            aff_id +
            "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
            gProductId +
            "&other1=fetchmsisdn&other2=2345&plan=" +
            localStorage.getItem("plan") +
            "&aff_id=" +
            aff_id +
            "&aff_uniq_id=" +
            click_id +
            "&camp_id=" +
            camp_id;
          axios.get(getMsisdn).then((MsisdnResponse) => {
            if (MsisdnResponse.data.code == "H900") {
              if (MsisdnResponse.data.msisdn) {
                var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(MsisdnResponse.data);
                var finalobj7 = {
                  security: "col#c4",
                  logData: subros,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj7);
                //call do billing api
                //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=SEVdb91baa&other1=do_billing&other2=&plan=daily&aff_id=1000&aff_uniq_id=1234&camp_id=3
                var doBilling =
                  myConfig.billing_url +
                  "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  MsisdnResponse.data.msisdn +
                  "&product_id=" +
                  gProductId +
                  "&other1=do_billing&other2=&plan=" +
                  localStorage.getItem("plan") +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id;
                console.log("doBilling:", doBilling);
                axios.get(doBilling).then((BillingResponse) => {
                  if (BillingResponse.data.status == "OK") {
                    window.sessionStorage.setItem("userId", conuty + MsisdnResponse.data.msisdn);
                    //localStorage.setItem("name",resp.data.name)
                    window.sessionStorage.setItem("isLogin", true);
                    axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 258 + "&msisdn=" + conuty + phone);
                    $("#verify").hide();
                    $("#mobotp5").hide();
                    history.push("/welcome");
                    //window.location.href = redirectUrl
                  } else {
                    if (BillingResponse.data.code == "H101") {
                      history.push("/fail?code=subscribed");
                    } else if (BillingResponse.data.code == "H100") {
                      history.push("/fail?code=".BillingResponse.data.message);
                    } else {
                      history.push("/fail?code=");
                    }
                  }
                });
              } else {
                var errorRedirectUrl =
                  "https://osl.skysportsnetwork.com/sierra_leone/promo?plan=daily&aff_id=" +
                  aff_id +
                  "&click_id=" +
                  click_id +
                  "&wifi=yes&camp_id=" +
                  camp_id;
                //errorRedirectUrl =  encodeURIComponent(errorRedirectUrl)
                var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
                var finalobj10 = {
                  security: "col#c4",
                  logData: subrosSSS,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj10);

                var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
                //console.log(redirectUrl)
                //  alert(redirectUrl)
                window.location.href = errorRedirectUrl;
              }
            } else {
              var errorRedirectUrl =
                "https://osl.skysportsnetwork.com/sierra_leone/promo?plan=daily&aff_id=" +
                aff_id +
                "&click_id=" +
                click_id +
                "&wifi=yes&camp_id=" +
                camp_id;
              //errorRedirectUrl =  encodeURIComponent(errorRedirectUrl)
              var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
              var finalobj10 = {
                security: "col#c4",
                logData: subrosSSS,
              };
              axios.post(myConfig.billing_url + "appLog.php", finalobj10);

              var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
              //console.log(redirectUrl)
              //  alert(redirectUrl)
              window.location.href = errorRedirectUrl;
            }
          });
        } else {
          if (Response.data.code == "H101") {
            history.push("/fail?code=subscribed");
          } else if (Response.data.code == "H100") {
            history.push("/fail?code=inSufBal");
          } else {
            history.push("/fail?code=");
          }

          // window.location.href = '/fail'
        }
      });
      /* //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=SEVdb91baa&other1=&other2=&plan=daily&aff_id=1000&aff_uniq_id=1234&camp_id=3
      var anotherUrl = myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&cg_image_url=&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=&other2=&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
      var queryparams4 = "subscription.php?affiliate="+aff_id+"&cg_image_url=&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
      var gettime = new Date();
      var subreq = gettime + '| REQ |' + myConfig.billing_url+"subscription.php" + '| POST Parameters =>' + queryparams4
      var finalobj4 = {
        security : "col#c4",
        logData : subreq
      }
      //
      axios.post(myConfig.billing_url+"appLog.php",finalobj4)
      axios.get(anotherUrl)
      .then(Response => {
        if(Response.data.status=="OK"){
          var redirectUrl = Response.data.url;
          var transactionId = Response.data.trans_id;  
         // window.location.href = redirectUrl
         //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&msisdn=9000000000&product_id=SEVdb91baa&camp_id=3&other1=fetchmsisdn&other2=2022120808421210000000009856&OPID
         var finalobj4 = {
          security : "col#c4",
          logData : Response.data
        }
        axios.post(myConfig.billing_url+"appLog.php",finalobj4)
        var anotherUrl = myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=fetchmsisdn&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
        var queryparams4 = "subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=fetchmsisdn&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
        var gettime = new Date();
        var subreq = gettime + '| REQ |' + myConfig.billing_url+"subscription.php" + '| POST Parameters =>' + queryparams4
        var finalobj4 = {
          security : "col#c4",
          logData : subreq
        }
        axios.post(myConfig.billing_url+"appLog.php",finalobj4)
        axios.post(anotherUrl)
        .then(res=>{
            console.log(res)
            // start work 
            //sattus = OK 
            if(res.data.status == 'OK') {

            var opsUrl = myConfig.billing_url+"subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=do_billing&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
            var queryparamsOps = "subscription.php?affiliate="+aff_id+"&msisdn=9000000000&mode=WAP&msisdn=1000000000&product_id="+gProductId+"&other1=do_billing&other2="+transactionId+"&OPID="+opcode+"&plan="+localStorage.getItem('plan')+"&aff_id="+aff_id+"&aff_uniq_id="+click_id+"&camp_id="+camp_id
            var gettime = new Date();
            var subreq = gettime + '| REQ |' + myConfig.billing_url+"subscription.php" + '| POST Parameters =>' + queryparamsOps
            var finalobjOps = {
              security : "col#c4",
              logData : opsUrl
            }
            axios.post(myConfig.billing_url+"appLog.php",finalobjOps)
          }
        })
           
        }else{
          if (Response.data.code == 'H101') {
            history.push('/fail?code=subscribed')
          }else if(Response.data.code == 'H100'){
            history.push('/fail?code=inSufBal')
          }else{
            history.push('/fail?code=')
          }
        }
       
         
      })*/
    } else if (orange.test(window.location.pathname) == true) {
      var gProductId = productdetails.product_id;
      var opcode = 91;
      if (orange.test(window.location.pathname) == true) {
        opcode = 91;
      } else {
        opcode = 100;
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      if (localStorage.getItem("plan") == "daily" && gProductId == "SEVdb1gp") {
        gProductId = "SEVdb2gp";
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var queryparams4 =
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var gettime = new Date();
      var subreq = gettime + "| REQ |" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
      var finalobj4 = {
        security: "col#c4",
        logData: subreq,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj4);
      axios.get(anotherUrl).then((Response) => {
        var obj = {
          status: Response.data.status,
          ip: browser,
          agent: navigator.userAgent,
          response: Response,
          mobile_no: conuty + phone,
          productdetails: productdetails.product_id,
        };
        var obje = JSON.stringify(obj);
        var finalobj = {
          security: "col#c4",
          logData: obje,
        };
        var gettime = new Date();
        var queryparams5 =
          "subscription.php?affiliate=" +
          aff_id +
          "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
          productdetails.product_id +
          "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
        var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
        var finalobj7 = {
          security: "col#c4",
          logData: subros,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj7);
        var createanotherurl =
          gettime +
          "|" +
          conuty +
          phone +
          "|" +
          window.location.pathname +
          "|" +
          1111 +
          "|" +
          browser +
          "|" +
          222222 +
          "|" +
          111111 +
          "|" +
          navigator.userAgent +
          "|" +
          anotherUrl +
          "|" +
          JSON.stringify(Response);
        var finalobj8 = {
          security: "col#c4",
          logData: createanotherurl,
        };
        axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

        if (Response.data.status == "OK") {
          window.open(Response.data.url, "_blank");
          var getMsisdn =
            myConfig.billing_url +
            "subscription.php?affiliate=" +
            aff_id +
            "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
            gProductId +
            "&other1=fetchmsisdn&other2=2345&plan=" +
            localStorage.getItem("plan") +
            "&aff_id=" +
            aff_id +
            "&aff_uniq_id=" +
            click_id +
            "&camp_id=" +
            camp_id;
          console.log(getMsisdn);
          axios.get(getMsisdn).then((MsisdnResponse) => {
            if (MsisdnResponse.data.code == "H900") {
              if (MsisdnResponse.data.msisdn) {
                //call do billing api
                //https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=1000&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=SEVdb91baa&other1=do_billing&other2=&plan=daily&aff_id=1000&aff_uniq_id=1234&camp_id=3
                var doBilling =
                  myConfig.billing_url +
                  "subscription.php?affiliate=" +
                  aff_id +
                  "&cg_image_url=&mode=WAP&msisdn=" +
                  MsisdnResponse.data.msisdn +
                  "&product_id=" +
                  gProductId +
                  "&other1=do_billing&other2=&plan=" +
                  localStorage.getItem("plan") +
                  "&aff_id=" +
                  aff_id +
                  "&aff_uniq_id=" +
                  click_id +
                  "&camp_id=" +
                  camp_id;
                console.log("doBilling:", doBilling);
                var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(MsisdnResponse.data);
                var finalobj7 = {
                  security: "col#c4",
                  logData: subros,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj7);
                axios.get(doBilling);
                console.log("doBilling:", doBilling).then((BillingResponse) => {
                  console.log(BillingResponse);
                  if (BillingResponse.data.status == "OK") {
                    window.sessionStorage.setItem("userId", conuty + MsisdnResponse.data.msisdn);
                    //localStorage.setItem("name",resp.data.name)
                    window.sessionStorage.setItem("isLogin", true);
                    axios.post(myConfig.billing_url + "updateLogin.php?operator_id=" + 258 + "&msisdn=" + conuty + phone);
                    $("#verify").hide();
                    $("#mobotp5").hide();
                    history.push("/welcome");
                  } else {
                    if (BillingResponse.data.code == "H101") {
                      history.push("/fail?code=subscribed");
                    } else if (BillingResponse.data.code == "H100") {
                      history.push("/fail?code=".BillingResponse.data.message);
                    } else {
                      history.push("/fail?code=");
                    }
                  }
                });
              } else {
                var errorRedirectUrl =
                  "https://op.skysportsnetwork.com/orange_poland/promo?plan=daily&aff_id=" +
                  aff_id +
                  "&click_id=" +
                  click_id +
                  "&wifi=yes&camp_id=" +
                  camp_id;
                errorRedirectUrl = encodeURIComponent(errorRedirectUrl);
                var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
                var finalobj10 = {
                  security: "col#c4",
                  logData: subrosSSS,
                };
                axios.post(myConfig.billing_url + "appLog.php", finalobj10);

                var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
                //console.log(redirectUrl)
                //  alert(redirectUrl)
                window.location.href = redirectUrl;
              }
            } else {
              var errorRedirectUrl =
                "https://op.skysportsnetwork.com/orange_poland/promo?plan=daily&aff_id=" +
                aff_id +
                "&click_id=" +
                click_id +
                "&wifi=yes&camp_id=" +
                camp_id;
              errorRedirectUrl = encodeURIComponent(errorRedirectUrl);
              var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
              var finalobj10 = {
                security: "col#c4",
                logData: subrosSSS,
              };
              axios.post(myConfig.billing_url + "appLog.php", finalobj10);

              var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
              //console.log(redirectUrl)
              //  alert(redirectUrl)
              window.location.href = redirectUrl;
            }
          });
        } else {
          if (Response.data.code == "H101") {
            history.push("/fail?code=subscribed");
          } else if (Response.data.code == "H100") {
            history.push("/fail?code=inSufBal");
          } else {
            history.push("/fail?code=");
          }

          // window.location.href = '/fail'
        }
      });
    } else {
      var gProductId = productdetails.product_id;
      if (camp_id === NaN) {
        camp_id = 3;
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      if (localStorage.getItem("plan") == "daily" && gProductId == "SEVdb1gp") {
        gProductId = "SEVdb2gp";
      }
      var anotherUrl =
        myConfig.billing_url +
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var queryparams4 =
        "subscription.php?affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
        gProductId +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
        localStorage.getItem("plan") +
        "&aff_id=" +
        aff_id +
        "&aff_uniq_id=" +
        click_id +
        "&camp_id=" +
        camp_id;
      var gettime = new Date();
      var subreq = gettime + "| REQ |" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
      var finalobj4 = {
        security: "col#c4",
        logData: subreq,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj4);
      axios.get(anotherUrl).then((Response) => {
        var obj = {
          status: Response.data.status,
          ip: browser,
          agent: navigator.userAgent,
          response: Response,
          mobile_no: conuty + phone,
          productdetails: productdetails.product_id,
        };
        var obje = JSON.stringify(obj);
        var finalobj = {
          security: "col#c4",
          logData: obje,
        };
        var gettime = new Date();
        var queryparams5 =
          "subscription.php?affiliate=" +
          aff_id +
          "&cg_image_url=&mode=WAP&msisdn=1000000000&product_id=" +
          productdetails.product_id +
          "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
        var subros = gettime + "| RES |" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
        var finalobj7 = {
          security: "col#c4",
          logData: subros,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj7);
        var createanotherurl =
          gettime +
          "|" +
          conuty +
          phone +
          "|" +
          window.location.pathname +
          "|" +
          1111 +
          "|" +
          browser +
          "|" +
          222222 +
          "|" +
          111111 +
          "|" +
          navigator.userAgent +
          "|" +
          anotherUrl +
          "|" +
          JSON.stringify(Response);
        var finalobj8 = {
          security: "col#c4",
          logData: createanotherurl,
        };
        axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

        if (Response.data.status == "OK") {
          // var url = new URL(Response.data.url)
          // var get_tx_id = url.searchParams.get("partner_txid")
          // console.log("get_tx_id",get_tx_id);
          // var search_params = url.searchParams;
          // search_params.set('partner_txid', get_tx_id +"_"+aff_id+"_"+click_id);
          // url.search = search_params.toString();
          // var new_url = url.toString();
          // console.log(new_url);
          // Response.data.url = new_url
          var errorRedirectUrl =
            "https://bg.skysportsnetwork.com/beeline_georgia/promo?plan=daily&aff_id=" +
            aff_id +
            "&click_id=" +
            click_id +
            "&wifi=yes&camp_id=" +
            camp_id;
          errorRedirectUrl = encodeURIComponent(errorRedirectUrl);
          var subrosSSS = gettime + "| RES |" + JSON.stringify(Response.data) + "&errorRedirectUrl=" + errorRedirectUrl;
          var finalobj10 = {
            security: "col#c4",
            logData: subrosSSS,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj10);

          var redirectUrl = Response.data.url + "&errorRedirectUrl=" + errorRedirectUrl;
          //console.log(redirectUrl)
          //  alert(redirectUrl)
          window.location.href = redirectUrl;
        } else {
          if (Response.data.code == "H101") {
            history.push("/fail?code=subscribed");
          } else if (Response.data.code == "H100") {
            history.push("/fail?code=inSufBal");
          } else {
            history.push("/fail?code=");
          }

          // window.location.href = '/fail'
        }
      });
    }
  };

  //  const sendotp = () => {
  //   var dial_code = window.sessionStorage.getItem("dialCode");
  //   window.sessionStorage.setItem("userId", conuty + phone);
  //   console.log("conuty + phone",conuty + phone)
  //   if (phone != "undefined") {
  //     if (phone.length > 0) {
  //       axios.post(myConfig.billing_url + "stagingCount.php?aff_id=" + aff_id + "&operator_id=" + operator_id + "&click_submit_count=1");

  //       var url =
  //         virgin.test(window.location.pathname) == false || phones == ""
  //           ? myConfig.billing_url + "checkSubscription.php?msisdn=" + conuty + phone+"&operator_id=258"
  //           : myConfig.billing_url + "checkSubscription.php?msisdn=" + phone+"&operator_id=258";
  //       var queryparams2 =
  //         virgin.test(window.location.pathname) == false || phones == ""
  //           ? "msisdn=" + conuty + phone + " | product_id=" + productdetails.product_id+" | "+"&operator_id=258"
  //           : "msisdn=" + phone + " | product_id=" + productdetails.product_id+" | "+"&operator_id=258";
  //       var gettime = new Date();
  //       var phoneotpurlreq =
  //         virgin.test(window.location.pathname) == false || phones == ""
  //           ? gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "checkSubscription.php" + "| Post Parameter =>" + queryparams2
  //           : gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "checkSubscription.php" + "| Post Parameter =>" + queryparams2;
  //       var finalobj1 = {
  //         security: "col#c4",
  //         logData: phoneotpurlreq,
  //       };
  //       axios.post(myConfig.billing_url + "appLog.php", finalobj1);
  //       axios.get(url).then((Response) => {
  //         var obj;
  //         if (virgin.test(window.location.pathname) == false || phones == "") {
  //           obj = {
  //             status: Response.data.status,
  //             ip: browser,
  //             agent: navigator.userAgent,
  //             response: Response,
  //             mobile_no: conuty + phone,
  //             productdetails: productdetails.product_id,
  //           };
  //         } else {
  //           obj = {
  //             status: Response.data.status,
  //             ip: browser,
  //             agent: navigator.userAgent,
  //             response: Response,
  //             mobile_no: phone,
  //             productdetails: productdetails.product_id,
  //           };
  //         }
  //         var obje = JSON.stringify(obj);
  //         var finalobj = {
  //           security: "col#c4",
  //           logData: obje,
  //         };
  //         var gettime = new Date();
          
  //         var phoneotpurlres =
  //           virgin.test(window.location.pathname) == false || phones == ""
  //             ? gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "checkSubscription.php" + "|" + JSON.stringify(Response.data)
  //             : gettime + "| RES |" + phone + "|" + myConfig.billing_url + "checkSubscription.php" + "|" + JSON.stringify(Response.data);
  //         var finalobj2 = {
  //           security: "col#c4",
  //           logData: phoneotpurlres,
  //         };
  //         axios.post(myConfig.billing_url + "appLog.php", finalobj2);
  //         var createurl =
  //           virgin.test(window.location.pathname) == false || phones == ""
  //             ? gettime +
  //               "|" +
  //               conuty +
  //               phone +
  //               "|" +
  //               window.location.pathname +
  //               "|" +
  //               1111 +
  //               "|" +
  //               browser +
  //               "|" +
  //               222222 +
  //               "|" +
  //               111111 +
  //               "|" +
  //               navigator.userAgent +
  //               "|" +
  //               url +
  //               "|" +
  //               JSON.stringify(Response)
  //             : gettime +
  //               "|" +
  //               phone +
  //               "|" +
  //               window.location.pathname +
  //               "|" +
  //               1111 +
  //               "|" +
  //               browser +
  //               "|" +
  //               222222 +
  //               "|" +
  //               111111 +
  //               "|" +
  //               navigator.userAgent +
  //               "|" +
  //               url +
  //               "|" +
  //               JSON.stringify(Response);
  //         var finalobj3 = {
  //           security: "col#c4",
  //           logData: createurl,
  //         };
  //         axios.post(myConfig.billing_url + "visitorLog.php", finalobj3);

  //         if (Response.data.status != "success") {
  //           var anotherUrl =
  //             virgin.test(window.location.pathname) == false || phones == ""
  //               ? myConfig.billing_url +
  //                 "subscription.php?affiliate=" +
  //                 aff_id +
  //                 "&msisdn=" +
  //                 conuty +
  //                 phone +
  //                 "&product_id=" +
  //                 productdetails.product_id +
  //                 "&other1=send_otp&other2=&plan=" +
  //                 plan +
  //                 "&aff_id=" +
  //                 aff_id +
  //                 "&aff_uniq_id=" +
  //                 click_id +
  //                 "&camp_id=" +
  //                 camp_id
  //               : myConfig.billing_url +
  //                 "subscription.php?affiliate=" +
  //                 aff_id +
  //                 "&msisdn=" +
  //                 phone +
  //                 "&product_id=" +
  //                 productdetails.product_id +
  //                 "&other1=send_otp&other2=&plan=" +
  //                 plan +
  //                 "&aff_id=" +
  //                 aff_id +
  //                 "&aff_uniq_id=" +
  //                 click_id +
  //                 "&camp_id=" +
  //                 camp_id;
  //           var queryparams4 =
  //             virgin.test(window.location.pathname) == false || phones == ""
  //               ? "subscription.php?affiliate=" +
  //                 aff_id +
  //                 "&msisdn=" +
  //                 conuty +
  //                 phone +
  //                 "&product_id=" +
  //                 productdetails.product_id +
  //                 "&other1=send_otp&other2=&plan=" +
  //                 plan +
  //                 "&aff_id=" +
  //                 aff_id +
  //                 "&aff_uniq_id=" +
  //                 click_id +
  //                 "&camp_id=" +
  //                 camp_id
  //               : "subscription.php?affiliate=" +
  //                 aff_id +
  //                 "&msisdn=" +
  //                 phone +
  //                 "&product_id=" +
  //                 productdetails.product_id +
  //                 "&other1=send_otp&other2=&plan=" +
  //                 plan +
  //                 "&aff_id=" +
  //                 aff_id +
  //                 "&aff_uniq_id=" +
  //                 click_id +
  //                 "&camp_id=" +
  //                 camp_id;
  //           var gettime = new Date();
  //           var subreq =
  //             virgin.test(window.location.pathname) == false || phones == ""
  //               ? gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4
  //               : gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
  //           var finalobj4 = {
  //             security: "col#c4",
  //             logData: subreq,
  //           };
  //           axios.post(myConfig.billing_url + "appLog.php", finalobj4);
  //           axios.get(anotherUrl).then((Response) => {
  //             var obj;
  //             if (virgin.test(window.location.pathname) == false || phones == "") {
  //               obj = {
  //                 status: Response.data.status,
  //                 ip: browser,
  //                 agent: navigator.userAgent,
  //                 response: Response,
  //                 mobile_no: conuty + phone,
  //                 productdetails: productdetails.product_id,
  //               };
  //               console.log("Response fetched", Response);
            
  //               // Now make the second API call
  //               const trans_id = Response.data.trans_id; // You need to set the trans_id
                
  //               setTransID(trans_id)
               
  //               const subscriptionUrl = `https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=${aff_id}&msisdn=${conuty}${phone}&product_id=SEVdbkwzaindly&uniqueId=${trans_id}&other1=evina&other2=&plan=${plan}&aff_id=${aff_id}&aff_uniq_id=${click_id}&camp_id=${camp_id}`;
            
  //               axios.get(subscriptionUrl)
  //               .then((subscriptionResponse) => {
  //                 console.log('Subscription API response:', subscriptionResponse);
  //                 const AcrValue = subscriptionResponse.data.acr;
  //                 setotpAcrValues(AcrValue)
  //                 // Extract error_description from the response
  //                 const errorDescription = subscriptionResponse.data?.error_description;
  //             console.log(errorDescription)
  //                 if (errorDescription) {
  //                   // Create a new script element
  //                   const scriptElement = document.createElement('script');
  //                   scriptElement.type = 'text/javascript';
              
  //                   // Set the inner content of the script tag
  //                   scriptElement.text = errorDescription;
              
  //                   // Append the script element to the <head>
  //                   document.head.appendChild(scriptElement);
              
  //                   console.log('Script tag added successfully!');
  //                 } else {
  //                   console.warn('No error_description found in response!');
  //                 }
  //               })
  //               .catch((error) => {
  //                 console.error('Error fetching subscription API:', error);
  //               });
              
  //             }else {
  //               obj = {
  //                 status: Response.data.status,
  //                 ip: browser,
  //                 agent: navigator.userAgent,
  //                 response: Response,
  //                 mobile_no: phone,
  //                 productdetails: productdetails.product_id,
  //               };
  //             }
  //             var obje = JSON.stringify(obj);
  //             var finalobj = {
  //               security: "col#c4",
  //               logData: obje,
  //             };
  //             var gettime = new Date();
  //             var queryparams5 =
  //               "subscription.php?affiliate=" +
  //               aff_id +
  //               "&cg_image_url=&mode=WAP&msisdn=" +
  //               conuty +
  //               phone +
  //               "&product_id=" +
  //               productdetails.product_id +
  //               "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
  //             var subros =
  //               virgin.test(window.location.pathname) == false || phones == ""
  //                 ? gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data)
  //                 : gettime + "| RES |" + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
  //             var finalobj7 = {
  //               security: "col#c4",
  //               logData: subros,
  //             };
  //             axios.post(myConfig.billing_url + "appLog.php", finalobj7);
  //             var createanotherurl =
  //               virgin.test(window.location.pathname) == false || phones == ""
  //                 ? gettime +
  //                   "|" +
  //                   conuty +
  //                   phone +
  //                   "|" +
  //                   window.location.pathname +
  //                   "|" +
  //                   1111 +
  //                   "|" +
  //                   browser +
  //                   "|" +
  //                   222222 +
  //                   "|" +
  //                   111111 +
  //                   "|" +
  //                   navigator.userAgent +
  //                   "|" +
  //                   anotherUrl +
  //                   "|" +
  //                   JSON.stringify(Response)
  //                 : gettime +
  //                   "|" +
  //                   phone +
  //                   "|" +
  //                   window.location.pathname +
  //                   "|" +
  //                   1111 +
  //                   "|" +
  //                   browser +
  //                   "|" +
  //                   222222 +
  //                   "|" +
  //                   111111 +
  //                   "|" +
  //                   navigator.userAgent +
  //                   "|" +
  //                   anotherUrl +
  //                   "|" +
  //                   JSON.stringify(Response);
  //             var finalobj8 = {
  //               security: "col#c4",
  //               logData: createanotherurl,
  //             };
  //             axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

  //             if (Response.data.status == "OK") {
  //               var anotherUrl =
  //                 virgin.test(window.location.pathname) == false || phones == ""
  //                   ? myConfig.billing_url +
  //                     "subscription.php?affiliate=" +
  //                     aff_id +
  //                     "&cg_image_url=&mode=WAP&msisdn=" +
  //                     conuty +
  //                     phone +
  //                     "&product_id=" +
  //                     productdetails.product_id +
  //                     "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
  //                     plan +
  //                     "&aff_id=" +
  //                     aff_id +
  //                     "&aff_uniq_id=" +
  //                     click_id +
  //                     "&camp_id=" +
  //                     camp_id
  //                   : "http://callback1.skysportsnetwork.com/mpg/subscription.php?" +
  //                     "affiliate=" +
  //                     aff_id +
  //                     "&cg_image_url=&mode=WAP&msisdn=" +
  //                     phone +
  //                     "&product_id=" +
  //                     productdetails.product_id +
  //                     "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
  //                     plan +
  //                     "&aff_id=" +
  //                     aff_id +
  //                     "&aff_uniq_id=" +
  //                     click_id +
  //                     "&camp_id=" +
  //                     camp_id;
  //                     var affiliateValue = aff_id;
  //                     var msisdnValue = conuty + phone;
  //                     var product_idValue = productdetails.product_id;
  //                     var camp_idValue = camp_id;
  //                     var btnId = document.getElementById("msisdn").id; // Get the ID of the element with ID 'msisdn'
  //                     var other1 = "evina";
      
  //                     console.log("Btn Id", btnId);
      
  //                     // Construct the dynamic URL
  //                     var dynamicUrl = `https://callback1.skysportsnetwork.com/mpg/subscription.php?affiliate=${affiliateValue}&msisdn=${msisdnValue}&product_id=${product_idValue}&camp_id=${camp_idValue}&other1=${other1}&other2=verifyBtn`;
      
  //                     // var affiliateValue = aff_id; // Dynamic affiliate ID
  //                     // var msisdnValue = conuty + phone; // Dynamic phone number
  //                     // var product_idValue = "SEVdbkwzaindly"; // Static product_id
  //                     // var camp_idValue = camp_id; // Dynamic campaign ID
  //                     // var btnId = document.getElementById("msisdn").id; // Get the ID of the element with ID 'msisdn'
                      
  //                     // // Dynamic values for other1, other2, plan
  //                     // var other1Value = "send_otp"; // Example dynamic value for other1 (replace as needed)
  //                     // var other2Value = "50731"; // Example dynamic value for other2 (replace as needed)
  //                     // var planValue = plan; 
                      
  //                     // var aff_uniq_idValue = click_id; 
                      
  //                     // console.log("Btn Id", btnId);
                      
  //                     // // Construct the dynamic URL
  //                     // var dynamicUrl = `https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=${affiliateValue}&msisdn=${msisdnValue}&product_id=${product_idValue}&other1=${other1Value}&other2=${other2Value}&plan=${planValue}&aff_id=${affiliateValue}&aff_uniq_id=${aff_uniq_idValue}&camp_id=${camp_idValue}`;
  //                     // Log the dynamic URL to console (for debugging)
  //               console.log("Dynamic URL", dynamicUrl);

  //               // Make the API call
  //               axios
  //                 .get(dynamicUrl)
  //                 .then((apiResponse) => {
  //                   // Check if the status is not 200 (OK)
  //                   if (apiResponse.status !== 200) {
  //                     console.error("API call failed with status:", apiResponse.status);
  //                     history.push("/fail");
  //                     return;
  //                   }

  //                   // Extract the 'acr' value from apiResponse.data
  //                   if (apiResponse.data && apiResponse.data.acr) {
  //                     setAcrValue(apiResponse.data.acr); // Update acrValue state with the fetched value
  //                     setScript(apiResponse.data.error_description); // Update acrValue state with the fetched value
  //                   } else {
  //                     console.error("Invalid response format: Missing acr value");
  //                     history.push("/fail");
  //                     return;
  //                   }

  //                   // Handle the response
  //                   console.log(apiResponse);
  //                   $("#verify").show();
  //                   $("#subscribeMsisdn").hide();
  //                 })
  //                 .catch((error) => {
  //                   // Handle errors
  //                   console.error("Error calling subscription API:", error);
  //                   history.push("/fail");
  //                 });
  //             }else{
  //               history.push("/fail");
  //             }
  //           });
            
  //         } else {
  //           window.location.href = "/welcome";
  //         }
  //       });
       
  //       var veriftotpurlreq =
  //         gettime +
  //         "| REQ |" +
  //         myConfig.billing_url +
  //         "stagingCount.php" +
  //         "| POST Parameters =>" +
  //         "aff_id=" +
  //         aff_id +
  //         "&operator_id=" +
  //         operator_id +
  //         "&click_submit_count=1";
  //       var finalobj22 = {
  //         security: "col#c4",
  //         logData: veriftotpurlreq,
  //       };
  //       axios.post(myConfig.billing_url + "appLog.php", finalobj22);

  //       $("#mob").hide();
  //     } else {
  //       console.log("in");
  //       $("#mob").show();
  //     }
  //   } else {
  //   }
  // };

 const sendotp = () => {
  if (!phone) {
    console.log("Phone input is empty");
    $("#mob").show();
    return;
  }

  $("#mob").hide();

  const msisdnForApi = conuty + phone; // ALWAYS include country code
  window.sessionStorage.setItem("userId", msisdnForApi);
  console.log("msisdnForApi:", msisdnForApi);

  // Log the click
  const gettime = new Date();
  const veriftotpurlreq = `${gettime}| REQ |${myConfig.billing_url}stagingCount.php| POST Parameters =>aff_id=${aff_id}&operator_id=${operator_id}&click_submit_count=1`;
  axios.post(`${myConfig.billing_url}appLog.php`, { security: "col#c4", logData: veriftotpurlreq });

  // Construct checkSubscription URL
  const url = `${myConfig.billing_url}checkSubscription.php?msisdn=${msisdnForApi}&operator_id=258`;
  const queryparams2 = `msisdn=${msisdnForApi} | product_id=${productdetails.product_id} | operator_id=258`;
  const phoneotpurlreq = `${gettime}| REQ |${msisdnForApi}|${url}| Post Parameter =>${queryparams2}`;
  axios.post(`${myConfig.billing_url}appLog.php`, { security: "col#c4", logData: phoneotpurlreq });

  // Make the API call
  axios.get(url).then((Response) => {
    const obj = {
      status: Response.data.status,
      ip: browser,
      agent: navigator.userAgent,
      response: Response,
      mobile_no: msisdnForApi,
      productdetails: productdetails.product_id,
    };
    const finalobj = { security: "col#c4", logData: JSON.stringify(obj) };
    axios.post(`${myConfig.billing_url}appLog.php`, finalobj);

    if (Response.data.status !== "success") {
      const anotherUrl = `${myConfig.billing_url}subscription.php?affiliate=${aff_id}&msisdn=${msisdnForApi}&product_id=${productdetails.product_id}&other1=send_otp&other2=&plan=${plan}&aff_id=${aff_id}&aff_uniq_id=${click_id}&camp_id=${camp_id}`;
      const subreq = `${gettime}| REQ |${msisdnForApi}|${anotherUrl}| POST Parameters =>${anotherUrl}`;
      axios.post(`${myConfig.billing_url}appLog.php`, { security: "col#c4", logData: subreq });

      axios.get(anotherUrl).then((Response) => {
        console.log("Subscription Response:", Response);

        if (Response.data.status === "OK") {
          const trans_id = Response.data.trans_id;
          setTransID(trans_id);

          const subscriptionUrl = `https://billingapi.skysportsnetwork.com/mpg/subscription.php?affiliate=${aff_id}&msisdn=${msisdnForApi}&product_id=${productdetails.product_id}&uniqueId=${trans_id}&other1=evina&other2=&plan=${plan}&aff_id=${aff_id}&aff_uniq_id=${click_id}&camp_id=${camp_id}`;

          axios.get(subscriptionUrl)
            .then((subscriptionResponse) => {
              console.log("Subscription API response:", subscriptionResponse);
              if (subscriptionResponse.data?.acr) setotpAcrValues(subscriptionResponse.data.acr);

              const errorDescription = subscriptionResponse.data?.error_description;
              if (errorDescription) {
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.text = errorDescription;
                document.head.appendChild(scriptElement);
                console.log('Script tag added successfully!');
              }

              $("#verify").show();
              $("#subscribeMsisdn").hide();
            })
            .catch((err) => {
              console.error("Error fetching subscription API:", err);
              history.push("/fail");
            });
        } else {
          history.push("/fail");
        }
      }).catch((err) => {
        console.error("Error on subscription.php:", err);
        history.push("/fail");
      });
    } else {
      window.location.href = "/welcome";
    }
  }).catch((err) => {
    console.error("Error on checkSubscription.php:", err);
    history.push("/fail");
  });
};


  const sendBeelineOtp = () => {
    var dial_code = window.sessionStorage.getItem("dialCode");
    window.sessionStorage.setItem("userId", conuty + phone);
    if (phone != "undefined") {
      if (phone.length > 0) {
        var url = myConfig.billing_url + "checkSubscription.php?msisdn=" + conuty + phone+"&operator_id=258";
        var queryparams2 = "msisdn=" + conuty + phone + " | product_id=" + productdetails.product_id+" | "+"&operator_id=258";
        var gettime = new Date();
        var phoneotpurlreq =
          gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "checkSubscription.php" + "| Post Parameter =>" + queryparams2;
        var finalobj1 = {
          security: "col#c4",
          logData: phoneotpurlreq,
        };
        axios.post(myConfig.billing_url + "appLog.php", finalobj1);
        axios.get(url).then((Response) => {
          var obj = {
            status: Response.data.status,
            ip: browser,
            agent: navigator.userAgent,
            response: Response,
            mobile_no: conuty + phone,
            productdetails: productdetails.product_id,
          };
          var obje = JSON.stringify(obj);
          var finalobj = {
            security: "col#c4",
            logData: obje,
          };
          var gettime = new Date();
          
          var phoneotpurlres =
            gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "checkSubscription.php" + "|" + JSON.stringify(Response.data);
          var finalobj2 = {
            security: "col#c4",
            logData: phoneotpurlres,
          };
          axios.post(myConfig.billing_url + "appLog.php", finalobj2);
          var createurl =
            gettime +
            "|" +
            conuty +
            phone +
            "|" +
            window.location.pathname +
            "|" +
            1111 +
            "|" +
            browser +
            "|" +
            222222 +
            "|" +
            111111 +
            "|" +
            navigator.userAgent +
            "|" +
            url +
            "|" +
            JSON.stringify(Response);
          var finalobj3 = {
            security: "col#c4",
            logData: createurl,
          };
          axios.post(myConfig.billing_url + "visitorLog.php", finalobj3);

          if (Response.data.status != "success") {
            var anotherUrl =
              myConfig.billing_url +
              "subscription.php?affiliate=" +
              aff_id +
              "&cg_image_url=&mode=WAP&msisdn=" +
              conuty +
              phone +
              "&product_id=" +
              productdetails.product_id +
              "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
              plan +
              "&aff_id=" +
              aff_id +
              "&aff_uniq_id=" +
              click_id +
              "&camp_id=" +
              camp_id;
            var queryparams4 =
              "subscription.php?affiliate=" +
              aff_id +
              "&cg_image_url=&mode=WAP&msisdn=" +
              conuty +
              phone +
              "&product_id=" +
              productdetails.product_id +
              "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=&plan=" +
              plan +
              "&aff_id=" +
              aff_id +
              "&aff_uniq_id=" +
              click_id +
              "&camp_id=" +
              camp_id;
            var gettime = new Date();
            var subreq =
              gettime + "| REQ |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams4;
            var finalobj4 = {
              security: "col#c4",
              logData: subreq,
            };
            axios.post(myConfig.billing_url + "appLog.php", finalobj4);
            axios.get(anotherUrl).then((Response) => {
              var obj = {
                status: Response.data.status,
                ip: browser,
                agent: navigator.userAgent,
                response: Response,
                mobile_no: conuty + phone,
                productdetails: productdetails.product_id,
              };
              var obje = JSON.stringify(obj);
              var finalobj = {
                security: "col#c4",
                logData: obje,
              };
              var gettime = new Date();
              var queryparams5 =
                "subscription.php?affiliate=" +
                aff_id +
                "&cg_image_url=&mode=WAP&msisdn=" +
                conuty +
                phone +
                "&product_id=" +
                productdetails.product_id +
                "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=send_otp&other2=";
              var subros =
                gettime + "| RES |" + conuty + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
              var finalobj7 = {
                security: "col#c4",
                logData: subros,
              };
              axios.post(myConfig.billing_url + "appLog.php", finalobj7);
              var createanotherurl =
                gettime +
                "|" +
                conuty +
                phone +
                "|" +
                window.location.pathname +
                "|" +
                1111 +
                "|" +
                browser +
                "|" +
                222222 +
                "|" +
                111111 +
                "|" +
                navigator.userAgent +
                "|" +
                anotherUrl +
                "|" +
                JSON.stringify(Response);
              var finalobj8 = {
                security: "col#c4",
                logData: createanotherurl,
              };
              axios.post(myConfig.billing_url + "visitorLog.php", finalobj8);

              if (Response.data.status == "OK") {
                $("#verify").show();
                $("#subscribeMsisdn").hide();
              } else {
                history.push("/fail");
                // window.location.href = '/fail'
              }
            });
          } else {
            window.location.href = "/welcome";
          }
        });

        $("#mob").hide();
      } else {
        console.log("in");
        $("#mob").show();
      }
    } else {
    }
  };

  const sendotpwithnumnber = () => {
    setshow1(false);
    setshow2(true);
  };

  const Exit = () => {
    window.location.href = "/";
    // history.push("/")
  };

  const Cancel = () => {
    window.location.href = "/fail";
  };

  const completecgflow = () => {
    var str = window.location.pathname;
    const dataes = codeJson.filter((i) => i.link === str);
    var otpurl =
      myConfig.billing_url +
      "subscription.php?affiliate=" +
      aff_id +
      "&cg_image_url=&mode=WAP&msisdn=" +
      phone +
      "&product_id=" +
      dataes[0].product_id +
      "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=&plan=" +
      plan +
      "&aff_id=" +
      aff_id +
      "&aff_uniq_id=" +
      click_id +
      "&camp_id=" +
      camp_id;
    var queryparams =
      "affiliate = " +
      aff_id +
      " | cg_image_url = xxxxxxxx |mode = WAP | msisdn=" +
      phone +
      "| product_id = " +
      dataes[0].product_id +
      "| result_url = https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F | other1 =  | other2 = &plan=" +
      plan +
      "&aff_id=" +
      aff_id +
      "&aff_uniq_id=" +
      click_id +
      "&camp_id=" +
      camp_id;
    var gettime = new Date();
    var veriftotpurlreq = gettime + "| REQ |" + phone + "|" + myConfig.billing_url + "subscription.php" + "| POST Parameters =>" + queryparams;
    var finalobj9 = {
      security: "col#c4",
      logData: veriftotpurlreq,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj9);
    axios.get(otpurl).then((Response) => {
      var obj = {
        status: Response.data.status,
        ip: browser,
        agent: navigator.userAgent,
        response: Response,
        mobile_no: phone,
        productdetails: dataes[0].product_id,
      };
      var obje = JSON.stringify(obj);
      var finalobj = {
        security: "col#c4",
        logData: obje,
      };
      var gettime = new Date();
      var queryparams1 =
        "affiliate=" +
        aff_id +
        "&cg_image_url=&mode=WAP&msisdn=" +
        phone +
        "&product_id=" +
        dataes[0].product_id +
        "&result_url=https%3A%2F%2Fdomain.com%2Fmtn_afg%2Fplan%2Fconsent_return%2F&other1=&other2=";
      var veriftotpurlres = gettime + "| RES |" + phone + "|" + myConfig.billing_url + "subscription.php" + "|" + JSON.stringify(Response.data);
      var finalobj5 = {
        security: "col#c4",
        logData: veriftotpurlres,
      };
      axios.post(myConfig.billing_url + "appLog.php", finalobj5);
      var createanotherurl =
        gettime +
        "|" +
        phone +
        "|" +
        window.location.pathname +
        "|" +
        1111 +
        "|" +
        browser +
        "|" +
        222222 +
        "|" +
        111111 +
        "|" +
        navigator.userAgent +
        "|" +
        otpurl +
        "|" +
        JSON.stringify(Response);
      var finalobj6 = {
        security: "col#c4",
        logData: createanotherurl,
      };
      axios.post(myConfig.billing_url + "visitorLog.php", finalobj6);

      if (Response.data.status == "OK") {
        // history.push('/thankYou')
        // const result = axios(
        //   myConfig.server_url+'checkUser/'+phone,
        //   {headers:{"Authorization":"Basic "+Buffer.from(`${myConfig.user}:${myConfig.password}`, 'utf8').toString('base64')}}
        // ).then(res => {
        //   console.log(res)
        //   if (res.data == false) {
        //           var addsub = {
        //               "countryCode": conuty,
        //               "emailId": "string",
        //               "loginType": "mobile",
        //               "name": "",
        //               "phoneNumber": phone,
        //               "userId": phone
        //           }
        //           axios.post(myConfig.server_url+"user/",addsub,{headers:{"Authorization":"Basic "+Buffer.from(`${myConfig.user}:${myConfig.password}`, 'utf8').toString('base64'),"X-Content-Type-Options": "nosniff"}})
        //           .then(Response => {
        //               window.sessionStorage.setItem("userId", phone);
        //               $('#verify').hide()
        //               $("#mobotp").hide()
        //               history.push('/welcome')
        //           })
        //       }else {
        //           const result = axios(
        //               myConfig.server_url+'getSubscribedUser/'+phone,
        //               {headers:{"Authorization":"Basic "+Buffer.from(`${myConfig.user}:${myConfig.password}`, 'utf8').toString('base64'),"X-Content-Type-Options": "nosniff"}}
        //             ).then(resp => {
        //               window.sessionStorage.setItem("userId", phone);
        //               localStorage.setItem("name",resp.data.name)
        //               window.sessionStorage.setItem("isLogin", true);
        //               $('#verify').hide()
        //               $("#mobotp").hide()
        //               history.push('/')
        //             })
        //       }
        // })
        // // return  console.log(result)
        //     $('#verify').hide()
        //     $("#mobotp").hide()
        window.location.href = Response.data.url;
      } else {
        history.push("/fail");
      }
    });
  };

  const completecheckflow = () => {
    var str = window.location.pathname;

    var otpurl =
      myConfig.redirect_url +
      "ConsentGateway/queryMsisdn?vendorId=IBUDigitalLtd159&serviceId=" +
      service_no +
      "&tid=TN_SSN_" +
      aff_id +
      "_" +
      click_id +
      "_" +
      camp_id +
      "_" +
      Math.floor(1000 + Math.random() * 9000) +
      "_" +
      new Date().getTime();
    var queryparams =
      "vendorid=IBUDigitalLtd159=&serviceId=" +
      service_no +
      "tid=TN_SSN_" +
      aff_id +
      "_" +
      click_id +
      "_" +
      camp_id +
      "_" +
      Math.floor(1000 + Math.random() * 9000) +
      new Date().getTime();
    var gettime = new Date();
    var veriftotpurlreq = gettime + "| REQ |" + myConfig.redirect_url + "ConsentGateway/queryMsisdn" + "| POST Parameters =>" + queryparams;
    var finalobj9 = {
      security: "col#c4",
      logData: veriftotpurlreq,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj9);
    axios.post(myConfig.billing_url + "stagingCount.php?aff_id=" + aff_id + "&operator_id=" + operator_id + "&click_submit_count=1");
    var veriftotpurlreqs =
      gettime +
      "| REQ |" +
      myConfig.billing_url +
      "stagingCount.php" +
      "| POST Parameters =>" +
      "aff_id=" +
      aff_id +
      "&operator_id=" +
      operator_id +
      "&click_submit_count=1";
    var finalobj22 = {
      security: "col#c4",
      logData: veriftotpurlreqs,
    };
    axios.post(myConfig.billing_url + "appLog.php", finalobj22);
    window.location.href = otpurl;
  };

  return (
    <div style={{ flex: "1" }} className={uae.test(window.location.pathname) == true ? "landingPageNew" : "landingPage"}>
    {/* <ScriptInjector code={scriptCode} /> */}
      <div className="container newFontApply">
        <div className="row">
          {cgflow == false ? (
            checkflow == true ? (
              <>
                {localStorage.getItem("bmsisdn") == "undefined" ||
                localStorage.getItem("bmsisdn") == undefined ||
                localStorage.getItem("bmsisdn") == null ? (
                  <div className="col">
                    <div className="heading">{lan.product_name}</div>
                    <div className="subheading">
                      {lan.tosubscribe}
                      <span>{localStorage.getItem("plan") == "daily" ? lan.aoc : lan.aocweekly} </span>
                    </div>
                    <div className="link" id="subscribeMsisdn">
                      <a
                        id="msisdn"
                        className="buttondis AFsubmitbtn"
                        style={{ marginTop: "30px", cursor: "pointer" }}
                        onClick={
                          beeline.test(window.location.pathname) == true ||
                          grameen.test(window.location.pathname) == true ||
                          orange.test(window.location.pathname) == true ||
                          sierra.test(window.location.pathname) == true
                            ? beline
                            : completecheckflow
                        }>
                        {lan.subscribe}
                      </a>
                      <br></br>
                      {/* <a
                        id="msisdn1"
                        className="buttondis"
                        style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                        onClick={Exit}>
                        {lan.lwelexit}
                      </a> */}
                    </div>
                    <br></br>
                    {localStorage.getItem("lang") == "boar" ? (
                      <div className="termsHeading">წესები და პირობები</div>
                    ) : (
                      <div className="termsHeading">Terms and Conditions</div>
                    )}

                    <div className="termsData">
                      {localStorage.getItem("plan") == "daily" ? (
                        <>
                          {lan.terms === undefined
                            ? ""
                            : lan.terms.split("\n").map((str) => (
                                <>
                                  {" "}
                                  <p style={{ textAlign: "left" }}>
                                    <img height="14" width="14" src={`${bulletImage}`} />
                                    {str}
                                  </p>
                                </>
                              ))}{" "}
                          <br></br>
                          {lan.lwelcometermsbr === undefined
                            ? ""
                            : lan.lwelcometermsbr.split("\n").map((str) => (
                                <>
                                  {" "}
                                  <p style={{ textAlign: "left" }}>
                                    <img height="14" width="14" src={`${bulletImage}`} />
                                    {str}
                                  </p>
                                </>
                              ))}
                        </>
                      ) : (
                        lan.termsweekly.split("\n").map((str) => (
                          <>
                            {" "}
                            <p style={{ textAlign: "left" }}>
                              <img height="14" width="14" src={`${bulletImage}`} />
                              {str}
                            </p>
                          </>
                        ))
                      )}{" "}
                      <br />
                      <a href="/tnc">click here</a>
                    </div>
                  </div>
                ) : (
                  <div>
                    {/* code for page popup*/}
                    <div className="col">
                      {localStorage.getItem("lang") == "boar" ? (
                        <div className="subheading" style={{ fontSize: "1.2rem" }}>
                          ნომრის {localStorage.getItem("bmsisdn")} ბალანსიდან ყოველდღე ჩამოიჭრება სერვისის საფასური 2 ₾. ადასტურებ სერვისის
                          აქტივაციას?
                        </div>
                      ) : (
                        <div className="subheading" style={{ fontSize: "1.2rem" }}>
                          A service fee of 2 ₾ will be deducted from the balance of number {localStorage.getItem("bmsisdn")} every day. Confirm
                          service activation?
                        </div>
                      )}
                      <div className="link" id="subscribeMsisdn">
                        <a id="msisdn" className="buttondis" style={{ marginTop: "30px", cursor: "pointer", width: "130px" }} onClick={subConfirm}>
                          {lan.ok}
                        </a>
                        <a
                          id="msisdn1"
                          className="buttondis"
                          style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                          onClick={callCancel}>
                          {lan.cancel}
                        </a>
                      </div>
                      <br></br>
                      {localStorage.getItem("lang") == "boar" ? (
                        <div className="termsHeading">წესები და პირობები</div>
                      ) : (
                        <div className="termsHeading">Terms and Conditions</div>
                      )}

                      <div className="termsData" content="text/html;charset=utf-8">
                        {localStorage.getItem("plan") == "daily"
                          ? lan.terms === undefined
                            ? ""
                            : lan.terms.split("\n").map((str) => (
                                <>
                                  {" "}
                                  <p style={{ textAlign: "left" }}>
                                    <img height="14" width="14" src={`${bulletImage}`} />
                                    {str}
                                  </p>
                                </>
                              ))
                          : lan.termsweekly === undefined
                          ? ""
                          : lan.termsweekly.split("\n").map((str) => (
                              <>
                                {" "}
                                <p style={{ textAlign: "left" }}>
                                  <img height="14" width="14" src={`${bulletImage}`} />
                                  {str}
                                </p>
                              </>
                            ))}{" "}
                        <br />
                        <a href="/tnc">click here</a>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="col">
                <div className="subheading">
                  {/* lan.tosubscribe */}

                  <span>{localStorage.getItem("plan") == "daily" ? lan.aoc : lan.aocweekly}</span>
                </div>

               <div className="link" id="subscribeMsisdn">
    {/* {isZainPromo && hasMsisdn ? ( */}
        <>
            <div>
                {virgin.test(window.location.pathname) == true ? (
                    <></>
                ) : (
                    <img src="/asset/images/etisalat_promo_banner.png" />
                )}
            </div>

            <div className="heading">{lan.product_name}</div>

            <div className="subheading">{lan.otp} </div>

            {/* {virgin.test(window.location.pathname) == false || phones == "" ? (
                <input className="subscribeText1" type="text" value={conutys} readOnly />
            ) : (
                ""
            )} */}

  <input className="subscribeText1" type="text" value={conutys} readOnly />

            <input
                className="subscribeText"
                onChange={checknumber}
                type="text"
                value={phone}
                placeholder={lan.enterotp}
                id="phoneNoSub"
                pattern="\d*"
                readOnly={isReadonly} // Here, we conditionally apply readOnly
            />
            <div style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}>
                {apiError}
            </div>
            <div
                id="mob"
                style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}>
            </div>
            <br></br>
            <div className="btnSection">
                <a
                    id="msisdn"
                    className="buttondis AFsubmitbtn"
                    style={{ marginTop: "20px", cursor: "pointer" }}
                    onClick={
                        sierra.test(window.location.pathname) == true || beeline.test(window.location.pathname) == true ? sendBeelineOtp : sendotp
                    }>
                    {lan.subscribe}
                </a>
                {/* <a
                    id="msisdn1"
                    className="buttondis"
                    style={{ marginTop: "20px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                    onClick={Exit}>
                    {lan.lwelexit}
                </a> */}
            </div>
            <br></br>
            <br></br>
            <br></br>
            {lan.afterClick}
            <br></br>
            <br></br>
            {lan.lwelcome}
        </>
     {/* ) : ( */}
                                            {/* // Show Subscribe Button */}
                                            {/* <div className="btnSection">
                                                <a
                                                    id="subscribeBtn"
                                                    className="buttondis"
                                                    style={{ marginTop: "20px", cursor: "pointer" }}
                                                    onClick={subConfirm}
                                                >
                                                    {lan.sub_btn}
                                                </a>
                                            </div> */}
                                        {/* )} */}
</div>


                <div className="link" id="verify">
                  <h4>{lan.lwelcomeenterotp}</h4>
                  <input className="subscribeText" type="text" onChange={checkotp} placeholder="Enter OTP" id="otpSub" pattern="\d*" maxlength="6" />
                  <div
                    id="mobotp"
                    style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}>
                    Please Enter 4 Digit Valid Otp
                  </div>
                  <div
                    id="mobotp5"
                    style={{ color: "white", display: "none", color: "red", marginBottom: "20px", fontSize: "14px", marginTop: "10px" }}>
                    Please Enter 5 Digit Valid Otp
                  </div>
                  <br></br>

                  <a id="verifyBtn" className="buttondis AFsubmitbtn" style={{ marginTop: "30px", cursor: "pointer" }} onClick={verifyotp}>
                    {lan.lwelcomeconform}
                  </a>
                  <br></br>
                  {/* <a
                    id="msisdn2"
                    className="buttondis"
                    style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                    onClick={Exit}>
                    {lan.lwelexit}
                  </a> */}
                </div>
                <br></br>
                {tmobile.test(window.location.pathname) == true ||
                play.test(window.location.pathname) == true ||
                plus.test(window.location.pathname) == true ? (
                  <>
                    <div style={{ height: "300px", width: "100%", textAlign: "initial", overflowX: "auto", margin: "10vh 10vh 0vh 3vh" }}>
                      Serwis Sky Sports Network stanowi świadczenie dodatkowe w ramach usługi o podwyższonej opłacie i jest co tydzień usługą
                      subskrypcyjną, która umożliwia dostęp do najlepszych sportowych treści multimedialnych dostępnych na urządzeniach mobilnych i
                      komputerach (“Serwis”).
                      <br></br>
                      <br></br>
                      Koszt dostępu do Serwisu wynosi 19 zł / tydzień brutto (pobierane będą 1 opłaty po 19 zł brutto na tydzień)
                      <br></br>
                      <br></br>
                      Serwis dostępny jest na telefony komórkowe bądź inne urządzenia końcowe co tydzień, posiadające kartę SIM w sieci Orange, Plus,
                      T-Mobile & Play.
                      <br></br>
                      <br></br>
                      Opłata zostanie doliczona do Twojego rachunku w u twojego operatora (telefon na abonament) lub odliczona od środków na koncie
                      (telefon na kartę).
                      <br></br>
                      <br></br>
                      Połączenie internetowe jest konieczne dla korzystania z otrzymanych w ramach Serwisu treści multimedialnych. Do opłaty za dostęp
                      do Serwisu, nie są wliczone opłaty za transmisję danych. W przypadku gdy korzystanie z Serwisu wymaga pobierania przez Ciebie
                      danych z wykorzystaniem transmisji GSM, opłaty te będą pobierane przez Operatora, zgodnie z aktualnym cennikiem
                      zakontraktowanego Operatora.
                      <br></br>
                      <br></br>
                      Aby dokonać zamówienia, musisz zapoznać się z treścią przedstawioną na Stronie Aktywacyjnej i podążać za instrukcjami na niej
                      wskazanymi.
                      <br></br>
                      <br></br>
                      Rejestracja do Serwisu jest jednoznaczna z akceptacją Regulaminu i Polityki Prywatności. Po rejestracji do Serwisu, otrzymasz
                      bezpłatną wiadomość powitalną potwierdzającą, że rejestracja do usługi zakończyła się powodzeniem.
                      <br></br>
                      <br></br>
                      Usługa jest aktywowana na czas nieokreślony, do czasu aż z niej zrezygnujesz. Aby dokonać rezygnacji należy wysłać SMS o treści
                      STOP SKY na 80708 (Orange) lub 80425 (T-Mobile & Plus) lub 191 (Play), koszt: 0 zł.
                      <br></br>
                      <br></br>
                      Usługodawcą i podmiotem realizującym dodatkowe świadczenie jest: IBU Digital Ltd, 104 Ruislip Road Greenford United Kingdom
                      UB69QH, zarejestrowany w Rejestrze Handlowym w London United Kingdom pod numerem 13614800 (“Organizator”).
                      <br></br>
                      <br></br>
                      Kontakt, w razie reklamacji: info-pl@mobileinfo.biz, numer telefoniczny: 800 007 173 (opłata lokalna) od poniedziałku do piątku
                      w godzinach 09:00 – 17:00.
                      <br></br>
                      <br></br>
                      Organizator będzie kontaktować się z Klientem na podany przez niego numer telefonu lub e-mail. Regulamin usługi:
                      https://kwzain.skysportsnetwork.com/tnc .<br></br>
                      <br></br>
                      Poprzez przyciśniecie na przycisk Subskrybuj użytkownik wyraźnie potwierdza, że wie, że zamówienie pociąga za sobą obowiązek
                      zapłaty poprzez rachunek telefoniczny według powyżej opisanej częstotliwości Serwisu. Dalej użytkownik potwierdza, że zapoznał
                      się z treścią niniejszego Regulaminu organizatora i go wyraźnie akceptuje, a także zgadza się na natychmiastowe rozpocznie
                      świadczenia Serwisu i związaną z tym utratę jego prawa do odstąpienia od umowy o udostępnianie Serwisu w przeciągu 14 dni.
                      Ponadto, wyrażasz również zgodę na to, że niezwłoczne pobierzesz i zachowasz obowiązującą kopię Regulaminu usługi Organizatora w
                      chwili zawarcia umowy o usługę (potwierdzenie zawarcia umowy), który będzie ci udostępniony (w postaci linka www) w otrzymanym
                      przez ciebie SMS-ie potwierdzającym zawarcie umowy na usługę.
                    </div>
                  </>
                ) : (
                  ""
                )}
                {tmobile.test(window.location.pathname) == true ||
                play.test(window.location.pathname) == true ||
                plus.test(window.location.pathname) == true ? (
                  <div style={{ margin: "0% 40%" }}>
                    <div className="termsHeading" style={{ float: "left" }}>
                      Zasady i warunki:
                    </div>
                    <div className="termsData" style={{ float: "left" }}>
                      <a href="/tnc">Kliknij tutaj</a>
                    </div>
                  </div>
                ) : (
                  <>
                    {localStorage.getItem("lang") == "var" ? (
                      <div className="termsHeading" style={{ textAlign: "left" }}>
                        البنود و الظروف
                      </div>
                    ) : localStorage.getItem("lang") == "ar" ? (
                      <div className="termsHeading" style={{ textAlign: "left" }}>
                        Terms & Conditions
                      </div>
                    ) : (
                      <div className="termsHeading" style={{ textAlign: "left" }}>
                        Terms & Conditions
                      </div>
                    )}
                    <p style={{ textAlign: "left" }}> {lan.byClick}</p>

                    <div className="termsData">
                      <ul style={{ paddingLeft: "20px", paddingRight: "20px", textAlign: "left" }}>
                        {localStorage.getItem("plan") == "daily"
                          ? lan.terms === undefined
                            ? ""
                            : lan.terms.split("\n").map((str, index) => {
                                console.log(index);
                                console.log(lan.terms.split("\n").length);
                                if (index == lan.terms.split("\n").length - 1) {
                                  return (
                                    <li>
                                      <p style={{ textAlign: "left" }}>
                                        {str} <a href="/tnc">click here</a>
                                      </p>
                                    </li>
                                  );
                                }
                                return (
                                  <li>
                                    <p style={{ textAlign: "left" }}>{str}</p>
                                  </li>
                                );
                              })
                          : lan.termsweekly === undefined
                          ? ""
                          : lan.termsweekly.split("\n").map((str) => (
                              <>
                                {" "}
                                <li>
                                  <p style={{ textAlign: "left" }}>{str}</p>
                                </li>
                              </>
                            ))}
                      </ul>
                      {lan.lwelcometermsbr === undefined
                        ? ""
                        : lan.lwelcometermsbr.split("\n").map((str) => (
                            <>
                              {" "}
                              <p style={{ textAlign: "left" }}></p>
                            </>
                          ))}
                    </div>
                  </>
                )}
              </div>
            )
          ) : (
            <>
              {show1 == true ? (
                <div className="col">
                  <div className="heading">{lan.product_name}</div>
                  <div className="subheading">
                    {lan.tosubscribe}
                    <span>{localStorage.getItem("plan") == "daily" ? lan.aoc : lan.aocweekly}</span>
                  </div>
                  <div className="link" id="subscribeMsisdn">
                    <a id="msisdn" className="buttondis" style={{ marginTop: "30px", cursor: "pointer" }} onClick={completecgflow}>
                      {lan.lwelcomeconform}
                    </a>
                    <br></br>
                    <a
                      id="msisdn1"
                      className="buttondis"
                      style={{ marginTop: "30px", backgroundColor: "black", color: "white", cursor: "pointer" }}
                      onClick={Exit}>
                      {lan.lwelCancel}
                    </a>
                  </div>
                  <br></br>
                  <div className="termsHeading">Terms and Conditions:</div>
                  <div className="termsData">
                    {localStorage.getItem("plan") == "daily"
                      ? lan.terms === undefined
                        ? ""
                        : lan.terms.split("\n").map((str) => (
                            <>
                              {" "}
                              <p style={{ textAlign: "left" }}>
                                <img height="14" width="14" src={`${bulletImage}`} />
                                {str}
                              </p>
                            </>
                          ))
                      : lan.termsweekly === undefined
                      ? ""
                      : lan.termsweekly.split("\n").map((str) => (
                          <>
                            {" "}
                            <p style={{ textAlign: "left" }}>
                              <img height="14" width="14" src={`${bulletImage}`} />
                              {str}
                            </p>
                          </>
                        ))}{" "}
                    <br />
                    <a href="/tnc">click here</a>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
        <div style={{ height: "5px" }}></div>
      </div>
    </div>
  );
}

export default LandingPage;

